import * as marietta from '../..';
import {
  ITEM_MODE_NO, MODE_AUXILIARY_TYPE_NO,
  QUOTATION_ITEM_LIST_MODE,
  QUOTATION_ITEM_LIST_TYPE_MODE,
} from '../Constants';
import {
  Beam, Column, Fitting, MonicaObject, PinPicture, Room, WallObject,
} from '../item';
import { ItemInfoCollection, PointCollection } from '../collection';
import { Wall } from '../item/parts';
import MasterItemCollection from '../collection/MasterItemCollection';
import { ThreeView } from '../../view3d/webcad';
import QuotationListCollection from '../collection/QuotationListCollection';
import { ObjectType } from '../../view3d/webcad/ObjectType';
import { AuxiliaryUtil, LocalStorageManager } from '../manager';
import DocumentCollection from '../collection/DocumentCollection';
import AuxiliaryConstructionCollection from '../collection/AuxiliaryConstructionCollection';
import {
  QuotationColumnList,
  QuotationList,
  RoomQuotation,
  StartsQuotationList,
} from '../../../marietta3d/AutoGen/StartsQuotationList';
import { PinDialogUtil } from '../../view3d/webcad/util/PinDialogUtil';
import QuotationAuxiliarySelectDialog from './dialog/QuotationAuxiliarySelectDialog';
import WebCADUtil from '../util/WebCADUtil';
import * as _ from 'underscore';
import { AuxiliaryDataInterface } from '../util/LiDAR/AuxiliaryInterface';

/** 作り直しの予約を実行するまでの時間(ms)。同じ操作の中で何度予約されても 1 回にまとめる */
const REBUILD_DELAY_MS: number = 0;
/** 読み込み中だったときに、作り直しを予約し直すまでの時間(ms) */
const REBUILD_RETRY_MS: number = 100;
/** 読み込み中のとき、作り直しを待つ回数の上限（読み込みが止まってフラグが戻らなくても、約 10 秒で作り直す） */
const REBUILD_RETRY_MAX: number = 100;
/** 仕様情報の表を入れる要素（スクロールもこの要素） */
const QUOTATION_LIST_DATA_ID: string = 'quotationListData';
/** 選んでいる行に付けるクラス */
const SELECTED_ROW_CLASS: string = 'selected';
/** 入力中とみなす要素（チェックボックスなど、押すだけの要素は除く） */
const EDITING_ELEMENT_SELECTOR: string = 'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]), select, textarea';

export interface AttachmentStorageData {
  id: string;
  document: DocumentCollection[];
}

export interface HabakInfo {
  index: number;
  itemInfo: ItemInfoCollection;
  habaki_guid: string;
  parentItem: MonicaObject;
  width: number;
  height: number;
  habaki_end_item_info: MasterItemCollection;
  habaki_documents: DocumentCollection[];
  price: string;
  room_name: string;
}

export default class QuotationItemList {
  lastSelectedRow: HTMLElement;

  mode: number;

  selectedItemGuidList: any[];

  roomItemList: Room[];

  fittingItemList: Fitting[];

  equipmentItemList: MonicaObject[];

  exteriorItemList: MonicaObject[];

  auxiliaryItemList: AuxiliaryConstructionCollection[];

  auxiliarySelectDialog: QuotationAuxiliarySelectDialog = new QuotationAuxiliarySelectDialog();

  beamItemList: Beam[];

  columnItemList: Column[];

  wallList: Wall[];

  tableDataWall: QuotationListCollection[];

  tableDataHabaki: QuotationListCollection[]; // 使用されていない模様 2024/11/29

  tableDataFloor: QuotationListCollection[];

  tableDataCeiling: QuotationListCollection[];

  tableDataFitting: QuotationListCollection[];

  tableDataEquipment: QuotationListCollection[];

  tableDataExterior: QuotationListCollection[];

  tableDataBeam: QuotationListCollection[];

  tableDataColumn: QuotationListCollection[];

  tableDataAuxiliary: QuotationListCollection[];

  tableDataQuotation: QuotationListCollection[];

  dataList: any;

  verticalResize: number;

  originInfo: { height: number, tbodyHeight: number, clickPos: number };

  /** 作り直しの予約（setTimeout の ID）。予約が無ければ null */
  private rebuildTimerId: number | null = null;

  /** 見積APIの要求の番号。最新の要求の応答だけを表に当てる */
  private estimateRequestNo: number = 0;

  /** 読み込み中で作り直しを待った回数 */
  private rebuildRetryCount: number = 0;

  /**
   * コンストラクタ
   */
  constructor() {
    // 表示中のリスト種別
    this.mode = 1;
    this.tableDataQuotation = [];
    const self = this;
    const radioButtons = document.querySelectorAll('input[name="checkInputMode"]');
    for (let i = 0; i < radioButtons.length; i += 1) {
      radioButtons[i].addEventListener('change', function () {
        const val: number = Number(this.value);
        self.mode = val;
        if (self.mode === QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO) {
          self.createAuxiliaryTable(self.mode);
        } else {
          self.createTable(self.mode);
        }

        marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode(true);
      });
    }
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isTablet || ua.isMobile) {
      document.querySelector('.resizeController')
        .addEventListener('touchstart', this.addResizeEvent, { passive: false });
    } else {
      document.querySelector('.resizeController')
        .addEventListener('mousedown', this.addResizeEvent);
    }
    if (JSON.parse(localStorage.getItem('list_verticalResize'))) {
      const data = JSON.parse(localStorage.getItem('list_verticalResize'));
      // リスト全体の高さの変更
      document.getElementById('footerMenuQuotationList').style.height = `${data.listHeight}px`;
      document.getElementById('footerMenuQuotationList')
        .style
        .setProperty('--listResize', `${data.tableBodyHeight}`); // 2D - 下のリスト
    }

    // 詳細計算ボタン
    document.getElementById('btnGetEstimate')
      .addEventListener('click', this.onClick_btnGetEstimate);
  }

  // データがあるか
  public get hasDataRows(): boolean {
    if (this.roomItemList?.length) return true;
    if (this.fittingItemList?.length) return true;
    if (this.equipmentItemList?.length) return true;
    if (this.exteriorItemList?.length) return true;
    return false;
  }

  addResizeEvent = (e: MouseEvent & TouchEvent) => {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    // リサイズの基準となる値の保存
    this.originInfo = {
      height: document.getElementById('footerMenuQuotationList').clientHeight,
      tbodyHeight: Number(document.getElementById('footerMenuQuotationList')
        .style
        .getPropertyValue('--listResize')),
      clickPos: ua.isTablet || ua.isMobile ? e.touches[0].clientY : e.clientY,
    };
    // カーソルの変更
    document.body.style.cursor = 'ns-resize';
    // 一時的に他のイベントを無効化
    document.getElementById('pageBodyLoader').style.pointerEvents = 'none';
    // アニメーション時間の変更(マウス追従にラグが出ないように)
    document.getElementById('footerMenuQuotationList').style.transition = '0s';
    if (ua.isTablet || ua.isMobile) {
      document.addEventListener('touchmove', this.resizeMouseMoveEvent, { passive: false });
      document.addEventListener('touchend', this.resizeMouseUpEvent, { passive: false });
    } else {
      document.addEventListener('mousemove', this.resizeMouseMoveEvent);
      document.addEventListener('mouseup', this.resizeMouseUpEvent);
    }
  };

  // リサイズ処理
  resizeMouseMoveEvent = (e: MouseEvent & TouchEvent) => {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    const defY = ua.isTablet || ua.isMobile ? e.touches[0].clientY : e.clientY;
    // クリックした位置からのマウス移動距離を取得
    const menuHeight = this.originInfo.clickPos - defY;
    // リサイズ値の範囲を制限
    if (((this.originInfo.height + menuHeight) > (document.getElementById('pageContainer').clientHeight - 110)) || ((this.originInfo.height + menuHeight) < 71)) return;
    // リサイズ値の保存
    this.verticalResize = menuHeight;
    // リスト全体の高さの変更
    document.getElementById('footerMenuQuotationList').style.height = `${this.originInfo.height + this.verticalResize}px`;
    // tbodyの高さ変更
    document.getElementById('footerMenuQuotationList')
      .style
      .setProperty('--listResize', `${this.originInfo.tbodyHeight + this.verticalResize}`); // 2D - 下のリスト
  };

  // リサイズの終了
  resizeMouseUpEvent = () => {
    document.body.style.cursor = 'auto';
    document.getElementById('pageBodyLoader').style.pointerEvents = 'all';
    document.getElementById('footerMenuQuotationList').style.transition = '0.5s';

    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isTablet || ua.isMobile) {
      document.removeEventListener('touchmove', this.resizeMouseMoveEvent);
      document.removeEventListener('touchend', this.resizeMouseUpEvent);
    } else {
      document.removeEventListener('mousemove', this.resizeMouseMoveEvent);
      document.removeEventListener('mouseup', this.resizeMouseUpEvent);
    }
    localStorage.setItem('list_verticalResize', JSON.stringify({
      listHeight: this.originInfo.height + this.verticalResize,
      tableBodyHeight: this.originInfo.tbodyHeight + this.verticalResize,
    }));
  };

  /**
   *見積書データの作成
   */
  public createData(updateTable: boolean = true, withBusy: boolean = true): void {
    if (!this.rebuildRows()) return;
    if (updateTable) this.drawTable();

    // このタイミングで実施をすると、表を更新する度に、メニューが切り替ってしまうので、タイミング変更
    // this.highlightQuotationItemList();

    marietta.webcad.WebCADGlobal.webcad2Dmanager.enableViewMode(true);

    // APIから見積一覧を取得
    this.onClick_btnGetEstimate_withBusy(withBusy);
  }

  /**
   * 仕様情報の行を作り直す（表は描かない）。階が無いときは何もせず false
   */
  public rebuildRows(): boolean {
    if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) return false;
    // 作り直す前に出した見積APIの要求は、古い行の数量なので応答を当てない
    this.estimateRequestNo += 1;

    this.createFitting();
    this.createRoomParts();
    // this.createFurniture();
    this.createEquipment();
    this.createExterior();
    this.createAuxiliary();
    this.joinTableData();
    return true;
  }

  /**
   * 表示中のタブの表を描く。付帯工事タブは描くときに付帯工事の行を作り直すので、行をまとめ直す
   */
  private drawTable(): void {
    if (this.mode === QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO) {
      this.createAuxiliaryTable(this.mode);
      this.joinTableData();
    } else {
      this.createTable(this.mode);
    }
  }

  /**
   * 種類ごとの行を、仕様情報の行（tableDataQuotation）にまとめる
   */
  private joinTableData(): void {
    this.tableDataQuotation = this.tableDataWall;
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataHabaki);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataFloor);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataCeiling);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataFitting);

    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataEquipment);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataExterior);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataBeam);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataColumn);
    this.tableDataQuotation = this.tableDataQuotation.concat(this.tableDataAuxiliary);
  }

  /**
   * 仕様情報の作り直しを予約する。同じ操作の中で何度呼ばれても、操作のあとに 1 回だけ作り直す
   */
  public requestRebuild = (): void => {
    this.scheduleRebuild(REBUILD_DELAY_MS);
  };

  /**
   * 予約を取り消して、今すぐ作り直す（作り直した表をすぐ使う操作や、Busy 表示の中で作り直す操作）
   */
  public flushNow(updateTable: boolean = true, withBusy: boolean = true): void {
    this.cancelRebuild();
    this.createData(updateTable, withBusy);
  }

  /** 予約が無ければ、作り直しを予約する */
  private scheduleRebuild(delayMs: number): void {
    if (this.rebuildTimerId !== null) return;
    this.rebuildTimerId = window.setTimeout(this.runRebuild, delayMs);
  }

  /** 予約と、入力を終えるのを待つ作り直しを取り消す（描き直しだけの待ちは、残っても害が無いので外さない） */
  private cancelRebuild(): void {
    document.getElementById(QUOTATION_LIST_DATA_ID)?.removeEventListener('focusout', this.requestRebuild);
    this.rebuildRetryCount = 0;
    if (this.rebuildTimerId === null) return;
    window.clearTimeout(this.rebuildTimerId);
    this.rebuildTimerId = null;
  }

  /**
   * 予約した作り直し。読み込み中は待ち（上限まで）、表に入力中は入力を終えてから行う（Busy は出さない）
   */
  private runRebuild = (): void => {
    this.rebuildTimerId = null;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isParsingObjects && this.rebuildRetryCount < REBUILD_RETRY_MAX) {
      this.rebuildRetryCount += 1;
      this.scheduleRebuild(REBUILD_RETRY_MS);
      return;
    }
    this.rebuildRetryCount = 0;
    if (this.waitUntilEditEnds(this.requestRebuild)) return;
    this.keepListView(() => this.createData(true, false));
  };

  /**
   * 表に入力中なら、入力を終えたときに onEnd を呼ぶようにして true
   * focusout は入力の change のあとに来るので、入力した値を反映してから描き直せる
   */
  private waitUntilEditEnds(onEnd: () => void): boolean {
    const listData: HTMLElement = document.getElementById(QUOTATION_LIST_DATA_ID);
    const active: Element = document.activeElement;
    if (!listData || !active || !listData.contains(active) || !active.matches(EDITING_ELEMENT_SELECTOR)) return false;
    listData.addEventListener('focusout', onEnd, { once: true });
    return true;
  }

  /** 見積APIの数量を入れた行で、表示中の表を描き直す（行は作り直さない） */
  private redrawCurrentTable = (): void => {
    this.keepListView(() => this.createTable(this.mode));
  };

  /**
   * 入力を終えたら、フォーカスの移動を待ってから描き直す
   * focusout は次の入力欄に移る前に来るので、すぐ描くと移った先の欄が消える。表の中で次の入力に移ったなら、また待つ
   */
  private redrawAfterEdit = (): void => {
    window.setTimeout(() => {
      if (!this.waitUntilEditEnds(this.redrawAfterEdit)) this.redrawCurrentTable();
    }, REBUILD_DELAY_MS);
  };

  /**
   * 表を描き直しても、スクロール位置と選んでいた行（部屋なら床・天井・壁の複数行）を残す
   */
  private keepListView(draw: () => void): void {
    const listData: HTMLElement = document.getElementById(QUOTATION_LIST_DATA_ID);
    const scrollTop: number = listData ? listData.scrollTop : 0;
    const scrollLeft: number = listData ? listData.scrollLeft : 0;
    const selectedRowIds: readonly string[] = listData
      ? Array.from(listData.querySelectorAll(`.${SELECTED_ROW_CLASS}`)).map((row: Element) => row.id).filter((id: string) => id !== '')
      : [];
    draw();
    if (!listData) return;
    selectedRowIds.forEach((id: string) => document.getElementById(id)?.classList.add(SELECTED_ROW_CLASS));
    listData.scrollTop = scrollTop;
    listData.scrollLeft = scrollLeft;
  }

  /**
   *詳細計算ボタンがクリックされた
   */
  private fetchEstimate(withBusy: boolean = false) {
    // 見積一覧がない場合は、取得さえやめる
    if (!this.tableDataQuotation || this.tableDataQuotation.length < 1) return;

    // APIから見積一覧を取得（後から出した要求があれば、古い応答は当てない）
    this.estimateRequestNo += 1;
    const requestNo: number = this.estimateRequestNo;
    marietta.webcad.WebCADGlobal.cadAPIManager.getStartsQuotationInfo(
      (dataFromApi: StartsQuotationList) => this.updateVolumeFromApiToTable(dataFromApi),
      withBusy,
      (): boolean => requestNo === this.estimateRequestNo,
    );
  }

  /** 詳細計算ボタンがクリックされた（busyフィルター付き） */
  public onClick_btnGetEstimate = () => this.fetchEstimate(true);

  /** 詳細計算ボタンがクリックされた(Busyフィルター指定) */
  private onClick_btnGetEstimate_withBusy = (withBusy: boolean = true) => this.fetchEstimate(withBusy);

  /**
   * APIから取得したデータをテーブルに反映する
   */
  public updateVolumeFromApiToTable = (dataFromApi: StartsQuotationList) => {
    const self: QuotationItemList = this;

    function setValue(table: QuotationListCollection, dataFromServer: QuotationList) {
      if (!table || !dataFromServer) return;

      table.area = (Math.round(dataFromServer.value * 1000) / 1000).toString();
      // unitの変換: API("m2") → 画面表示("㎡")
      if (dataFromServer.unit) {
        table.unit = dataFromServer.unit === 'm2' ? '㎡' : dataFromServer.unit;
      }
    }

    function setHeightValue(table: QuotationListCollection, dataFromServer: QuotationList) {
      if (!table || !dataFromServer) return;
      table.height = dataFromServer.height?.toString(10);
    }

    dataFromApi.estimate.room.forEach((item: RoomQuotation) => {
      // 天井
      setValue(self.tableDataQuotation.find((d) => d.guid === item.ceiling.guid), item.ceiling);
      // 床
      setValue(self.tableDataQuotation.find((d) => d.guid === item.floor.guid), item.floor);
      // 壁
      item.wall.forEach((wall: QuotationList) => {
        setValue(self.tableDataQuotation.find((d) => d.guid === wall.guid), wall);
      });
    });
    // 梁
    dataFromApi.estimate.beam.forEach((item: QuotationList) => {
      setValue(self.tableDataQuotation.find((d) => d.guid === item.guid), item);
    });

    // 柱　処理方法変更
    // dataFromApi.estimate.column.forEach( (item:QuotationList) => {
    //   setValue( self.tableDataQuotation.find( (d) => d.guid === item.guid ), item );
    // });

    // 柱
    dataFromApi.estimate.column.forEach((item: QuotationColumnList) => {
      // 壁
      item.surface.forEach((wall: QuotationList) => {
        // 巾木は高さ
        if (wall.guid.indexOf('habaki') > -1) {
          setHeightValue(self.tableDataQuotation.find((d) => d.guid === wall.guid), wall);
        } else {
          setValue(self.tableDataQuotation.find((d) => d.guid === wall.guid), wall);
        }
      });
    });

    // 壁
    dataFromApi.estimate.wall.forEach((item: QuotationList) => {
      // 巾木は高さ
      if (item.guid.indexOf('habaki') > -1) {
        setHeightValue(self.tableDataQuotation.find((d) => d.guid === item.guid), item);
      } else {
        setValue(self.tableDataQuotation.find((d) => d.guid === item.guid), item);
      }
    });

    // 表示の更新（付帯工事タブは見積APIの結果を反映する項目がないため更新しない）
    // 表に入力中なら、入力を消さないよう、入力を終えてから描き直す
    if (self.mode !== QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO && !self.waitUntilEditEnds(self.redrawAfterEdit)) {
      self.redrawCurrentTable();
    }
  };

  /**
   * create content based on the radio button (mode)
   * @param mode
   */
  createTable(mode: number = null) {
    document.getElementById('quotationListData').innerHTML = '';
    document.getElementById('quotationListData').classList.remove('auxiliaryTable')

    // 部屋
    const dataList = new Map();
    // dataList.set('is_quote', { name: `<input type="checkbox" data-mode="${mode}" class="quote_checkAll" id="quote_checkAll">`, name_en: '', align: 'center', type: 'checkbox' });
    dataList.set('is_quote', { name: `フィルタ<br><input type="checkbox" data-mode="${mode}" class="quote_checkOn" id="quote_checkOn">`, name_en: '', align: 'center', type: 'checkbox' });
    dataList.set('name', { name: 'アイテム名', name_en: 'Name', align: 'left', type: 'string' });
    dataList.set('room_name', { name: '部屋名', name_en: 'Room Name', align: 'left', type: 'string' });
    dataList.set('floor', { name: '階', name_en: 'Floor', align: 'center', type: 'string' });
    dataList.set('width', { name: '幅<br>(mm)', name_en: 'Width<br>(mm)', align: 'right', type: 'string' });
    dataList.set('depth', { name: '奥行<br>(mm)', name_en: 'Depth<br>(mm)', align: 'right', type: 'string' });
    dataList.set('height', { name: '高さ<br>(mm)', name_en: 'height<br>(mm)', align: 'right', type: 'string' });
    dataList.set('area', { name: '数量', name_en: 'Area', align: 'right', type: 'string' });
    dataList.set('unit', { name: '単位', name_en: 'Unit', align: 'center', type: 'textbox' });
    // dataList.set('z', { name: '設置高さ', name_en: 'Inst. Height', align: 'right', type: 'string' });
    dataList.set('maker', { name: 'メーカー名', name_en: 'Maker', align: 'left', type: 'textbox' });
    dataList.set('part_number', { name: '品番・型番', name_en: 'Code', align: 'left', type: 'textbox' });
    dataList.set('item_name', { name: '品名', name_en: 'Item Name', align: 'left', type: 'textbox' });
    dataList.set('item_sub_category', { name: '分類', name_en: 'Category', align: 'left', type: 'textbox' });
    dataList.set('unit_price', { name: '単価', name_en: 'Unit Price', align: 'right', type: 'textbox_number' });
    dataList.set('price', { name: '金額', name_en: 'Price', align: 'right', type: 'string' });
    dataList.set('item_set_date', { name: '設置日<br>（更新日）', name_en: 'date', align: 'center', type: 'textbox_date' });
    dataList.set('note', { name: '補足説明', name_en: 'Comment', align: 'left', type: 'textbox' });
    dataList.set('documents', { name: '添付資料', name_en: 'Documents', align: 'center', type: 'documents' });

    // dataList.set('guid', { name: 'GUID', name_en: 'GUID', align: 'center', type: 'string' });

    // dataList.set('isCeiling', { name: '天井付け有無', name_en: 'Ceiling', align: 'center', type: 'string' });
    this.dataList = dataList;

    let tableContent = '<table class="itemListTable">';
    tableContent += '<thead>';
    this.dataList.forEach((value, key) => {
      if (value.type === 'checkbox') {
        tableContent += `<th class="${key}">${value.name}</th>`;
      } else {
        tableContent += `<th class="${key}"><span class="jp">${value.name}</span><span class="en">${value.name_en}</span></th>`;
      }
    });
    tableContent += '<th><span class="jp">修繕履歴</span><span class="en">History</span></th>';
    tableContent += '</thead>';
    tableContent += '<tbody id="quoteTableBody">';
    tableContent += this.createTableRowContent(mode);
    tableContent += '</tbody>';
    tableContent += '</table>';
    tableContent += '<div class="tableUnderLine"></div>';
    const parser = new DOMParser();
    const content = parser.parseFromString(tableContent, 'text/html');
    document.getElementById('quotationListData')
      .appendChild(content.body.firstElementChild);
    document.getElementById('quotationListData')
      .appendChild(content.body.lastElementChild);

    this.setEvents();
  }

  /**
   * create content based on the radio button (mode)
   * @param mode
   */
  createAuxiliaryTable(mode: number = null) {
    this.createAuxiliary();
    console.group('[付帯工事テーブル] データ一覧');
    (this.tableDataAuxiliary ?? []).forEach((d, i) => {
      console.log(`[${i}]`, {
        guid:                 d.guid,
        付帯工事名:            d.name,
        other_flag:           d.other_flag,
        other_text:           d.other_text,
        部屋名:               d.room_name,
        紐づけアイテム:        d.intersectItem,
        数量:                 d.area,
        単位:                 d.unit,
        単価:                 d.unit_price,
        金額:                 d.price,
        入居者負担割合:        d.rate,
        修繕理由:             d.reason,
        備考:                 d.remarks,
        auxiliaryDatum:       d.parentPin?.itemInfo?.auxiliaryData?.auxiliaryDatum,
        pin_floor:            d.parentPin?.itemInfo?.floor,
        pin_x:                d.parentPin?.itemInfo?.x,
        pin_y:                d.parentPin?.itemInfo?.y,
        getRoomWithPin結果:   marietta.webcad.WebCADGlobal.webcad2Dmanager.getRoomWithPin(d.parentPin?.itemInfo)?.itemInfo?.text ?? '(null)',
      });
    });
    console.groupEnd();

    document.getElementById('quotationListData').innerHTML = '';
    document.getElementById('quotationListData').classList.add('auxiliaryTable')

    // 部屋
    const dataList = new Map();
    // dataList.set('is_quote', { name: `<input type="checkbox" data-mode="${mode}" class="quote_checkAll" id="quote_checkAll">`, name_en: '', align: 'center', type: 'checkbox' });
    dataList.set('is_quote', { name: `フィルタ<br><input type="checkbox" data-mode="${mode}" class="quote_checkOn" id="quote_checkOn">`, name_en: '', align: 'center', type: 'checkbox' });
    dataList.set('name', { name: '付帯工事名', name_en: 'Name', align: 'left', type: 'string' });
    dataList.set('room_name', { name: '部屋名', name_en: 'Room Name', align: 'left', type: 'room_name_list' });
    dataList.set('intersectItem', { name: '紐づけアイテム', name_en: 'Intersect Name', align: 'left', type: 'string' });
    dataList.set('area', { name: '数量', name_en: 'Area', align: 'right', type: 'textbox_number' });
    dataList.set('unit', { name: '単位', name_en: 'Unit', align: 'center', type: 'textbox' });
    dataList.set('unit_price', { name: '単価', name_en: 'Unit Price', align: 'right', type: 'textbox_number' });
    dataList.set('price', { name: '金額', name_en: 'Price', align: 'right', type: 'string' });
    dataList.set('rate', { name: '入居者負担割合', name_en: 'Burden', align: 'right', type: 'textbox_rate'});
    dataList.set('reason', { name: '修繕理由', name_en: 'Reason', align: 'right', type: 'list' });
    dataList.set('remarks', { name: '備考', name_en: 'Comment', align: 'left', type: 'textbox' });

    this.dataList = dataList;

    let tableContent = '<table class="itemListTable">';
    tableContent += '<thead>';
    this.dataList.forEach((value, key) => {
      if (value.type === 'checkbox') {
        tableContent += `<th class="${key}">${value.name}</th>`;
      } else {
        tableContent += `<th class="${key}"><span class="jp">${value.name}</span><span class="en">${value.name_en}</span></th>`;
      }
    });
    tableContent += '</thead>';
    tableContent += '<tbody id="quoteTableBody">';
    tableContent += this.createTableRowContent(mode);
    tableContent += '</tbody>';
    tableContent += '</table>';
    tableContent += '<div class="tableUnderLine"></div>';
    const parser = new DOMParser();
    const content = parser.parseFromString(tableContent, 'text/html');
    document.getElementById('quotationListData')
      .appendChild(content.body.firstElementChild);
    document.getElementById('quotationListData')
      .appendChild(content.body.lastElementChild);

    this.setEvents();
  }

  /**
   * 表の行の内容を作成する
   * @returns
   */
  updateRoomTextForAllTables(): void {
    // RoomTextの更新
    function updateRoomTextFromPosition(target: QuotationListCollection) {
      let item: MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(target.guid);
      if (!item) {
        item = marietta.webcad.WebCADGlobal.itemManager.getWallParentByGuid(target.guid);
      }

      if (item) {
        if (!item.itemInfo.parentRoom) item.setParentRoom();
        if (item.itemInfo.parentRoom) {
          target.item = item.itemInfo.parentRoom;
        }
      }
      target.room_name = target.item ? target.item.itemInfo.text : '';
    }

    let tables: QuotationListCollection[] = [];
    // tables = tables.concat(this.tableDataBeam, this.tableDataColumn, this.tableDataEquipment,this.tableDataExterior, this.tableDataFurniture, this.tableDataFitting);
    tables = tables.concat(this.tableDataBeam, this.tableDataColumn, this.tableDataEquipment, this.tableDataExterior, this.tableDataFitting);
    for (let i: number = 0; i < tables.length; i += 1) {
      // (tables[i]).updateRoomTextFromPosition();
      updateRoomTextFromPosition(tables[i]);
    }
    this.applyPinRoomNameToFittings();
  }

  /**
   * 表の行の内容を作成する
   * @param mode
   * @returns
   */
  createTableRowContent = (mode) => {
    let tableContent = '';
    switch (mode) {
      case QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO:
        // tableContent += this.createRoomPartsTableData();
        tableContent += this.createTable_(this.tableDataWall, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_WALL_TYPE_NO);
        tableContent += this.createTable_(this.tableDataHabaki, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_HABAKI_TYPE_NO);
        tableContent += this.createTable_(this.tableDataFloor, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FLOOR_TYPE_NO);
        tableContent += this.createTable_(this.tableDataCeiling, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_CEILING_TYPE_NO);
        tableContent += this.createTable_(this.tableDataBeam, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_BEAM_TYPE_NO);
        tableContent += this.createTable_(this.tableDataColumn, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_COLUMN_TYPE_NO);
        break;
      case QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO:
        tableContent += this.createTable_(this.tableDataFitting, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FITTING_TYPE_NO);
        break;

      case QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO:
        tableContent += this.createTable_(this.tableDataEquipment, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EQUIPMENT_TYPE_NO);
        break;

      case QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO:
        tableContent += this.createTable_(this.tableDataExterior, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EXTERIOR_TYPE_NO);
        break;

      case QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO:
        tableContent += this.createTable_(this.tableDataAuxiliary, QUOTATION_ITEM_LIST_TYPE_MODE.MODE_AUXILIARY_TYPE_NO);
        break;

      default:
        break;
    }
    return tableContent;
  };

  /**
   * すべてのイベントを設定
   */
  setEvents = () => {
    // 全てチェックのリスナー削除
    document.getElementById('quotationAllSelectCheckbox')
      .removeEventListener('change', this.onQuoteCheckAll);
    // チェックボックスのイベントを貼りながら、全てチェックされているかをチェック
    let isAllOn: boolean = true;
    document.querySelectorAll('.quote_check')
      .forEach((element: HTMLInputElement) => {
        if (!element.checked) isAllOn = false;
        element.addEventListener('change', this.onQuoteCheck);
      });
    // 全て選択のステータス変更・イベント貼り
    (<HTMLInputElement>document.getElementById('quotationAllSelectCheckbox')).checked = isAllOn;
    document.getElementById('quotationAllSelectCheckbox')
      .addEventListener('change', this.onQuoteCheckAll);

    document.getElementById('quote_checkOn')
      .addEventListener('click', (e) => {
        // 全domをみていって、順番を入れ替える
        if ((<HTMLInputElement>document.getElementById('quote_checkOn')).checked) {
          const nonPriorityList: Element[] = [];
          for (const element of document.getElementById('quoteTableBody').children) {
            if (!(<HTMLInputElement>element.querySelector('input[type="checkbox"]')).checked) {
              nonPriorityList.push(element);
            }
          }

          for (const element of nonPriorityList) {
            element.parentElement.removeChild(element);
          }
          for (const element of nonPriorityList) {
            document.getElementById('quoteTableBody')
              .appendChild(element);
          }
        } else {
          // 表の作り直し
          this.createData();
        }
      });

    document.querySelectorAll('.quote_textbox')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    document.querySelectorAll('.quote_room_name_text')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    document.querySelectorAll('.quote_room_name_text')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('focusout', (event)=>{
          if((<HTMLInputElement>event.target).value == ""){
            console.log((<HTMLInputElement>event.target))
            const guid = (<HTMLInputElement>event.target).getAttribute('data-guid');
            document.getElementById(`room_name_${guid}`).style.display = "inline-block";
            (<HTMLSelectElement> document.getElementById(`room_name_${guid}`)).selectedIndex = 0;
            document.getElementById(`room_name_text_${guid}`).style.display = "none";
          }
        });
      });

    document.querySelectorAll('.quote_textbox_number')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    document.querySelectorAll('.quote_list')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    document.querySelectorAll('.room_name_list')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    document.querySelectorAll('.quote_textbox_date')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('change', this.updateValue);
      });

    // 付帯工事テーブルの▼ボタンクリックで付帯工事選択ダイアログを表示
    document.querySelectorAll<HTMLElement>('#quotationListData.auxiliaryTable .btn_auxiliary_change')
      .forEach((btn) => {
        btn.addEventListener('click', (e: MouseEvent) => {
          e.stopPropagation();
          const guid = btn.getAttribute('data-guid');
          const td = btn.closest<HTMLElement>('td[data-property="name"]');

          this.auxiliarySelectDialog.open(guid, btn, (construction, middleCategory, subCategory, masterType) => {
            // 対象PINのauxiliaryDatumを更新
            const pin = (marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO) as any[])
              .find((p: any) => p.itemInfo?.guid === guid);
            if (pin?.itemInfo?.auxiliaryData?.auxiliaryDatum) {
              const datum = pin.itemInfo.auxiliaryData.auxiliaryDatum;
              datum.constructionId = construction.id;
              datum.construction = construction.name;
              datum.middleCategory = middleCategory;
              datum.subCategory = subCategory;
              datum.masterType = masterType;
              datum.unit = construction.unit;
              datum.unitPrice = construction.unit_price;
              datum.totalPrice = Math.floor((datum.quantity || 0) * construction.unit_price);
              datum.other_flag = construction.other_flag;
              datum.otherText = construction.other_flag ? construction.name : '';
            }
            console.log(construction, middleCategory, subCategory)

            // テーブルを再描画
            this.createAuxiliaryTable(this.mode);
          });
        });
      });

    const elements = document.getElementsByClassName('itemListContainer');
    for (let i = 0; i < elements.length; i += 1) {
      const isAuxiliaryRow = (elements[i] as HTMLElement).getAttribute('data-floor') === 'undefined';
      const handler = isAuxiliaryRow ? this.handleAuxiliarySelection : this.handleSelection;
      elements[i].addEventListener('click', handler, false);
    }

    // 修繕履歴
    document.querySelectorAll('.btnHistory')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('click', (e: MouseEvent) => {
          const parent = (e.target as HTMLElement).closest('.btnHistory.btn');

          const params = {
            item_id: parent.getAttribute('data-itemid'),
            guid: parent.getAttribute('data-guid'),
            room_name: parent.getAttribute('data-roomName'),
            plan_id: marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id,
          };
          const encodedParams = Object.keys(params)
            .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
          const url = new URL(`history/?${encodedParams}`, marietta.webcad.WebCADGlobal.webcad2Dmanager.lidar_url);
          window.open(url, '_blank');
        });
      });

    // 添付資料
    document.querySelectorAll('.btnDocumentsAdd')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('click', (e: MouseEvent) => {
          if ((<HTMLElement>e.target).nodeName.toLowerCase() !== 'button') e.stopPropagation();
          openDocumentPage(e);
        });
      });
    document.querySelectorAll('.btnDocumentsEdit')
      .forEach((element: HTMLInputElement) => {
        element.addEventListener('click', (e: MouseEvent) => {
          if ((<HTMLElement>e.target).nodeName.toLowerCase() !== 'button') e.stopPropagation();
          openDocumentPage(e);
        });
      });

    const openDocumentPage = (e: MouseEvent) => {
      let target: HTMLButtonElement;
      if (e.currentTarget) {
        target = (<HTMLButtonElement>e.currentTarget);
      } else {
        target = (<HTMLButtonElement>e.target);
      }
      const targetGuid = target.getAttribute('data-guid');
      const index = Number(target.getAttribute('data-arrayindex'));
      const type = target.getAttribute('itemtype');
      const params = {
        mode: 'tempu',
        articleId: marietta.webcad.WebCADGlobal.webcad2Dmanager.article_id,
        divisionId: marietta.webcad.WebCADGlobal.webcad2Dmanager.division_id,
        planId: marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id,
        planName: marietta.webcad.WebCADGlobal.webcad2Dmanager.plan_name,
        elementId: targetGuid,
      };
      const encodedParams = Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
      const storageManager = new LocalStorageManager();
      const setDocumentLocalStorage = () => {
        const allDocuments: AttachmentStorageData[] = storageManager.getItem('attachedDocument');
        if (allDocuments && Array.isArray(allDocuments)) {
          const documentIndex = allDocuments.findIndex((list: AttachmentStorageData) => list.id === params.elementId);
          const documentList = this.getDocumentsByGuid(targetGuid, index, type);
          if (documentIndex > -1) {
            allDocuments[documentIndex].document = this.getDocumentsByGuid(targetGuid, index, type);
          } else if (documentList?.length > 0) {
            const strorageInfo: AttachmentStorageData = {
              id: targetGuid,
              document: documentList,
            };
            allDocuments.push(strorageInfo);
          }
          storageManager.setItem('attachedDocument', allDocuments);
        }
      };
      // ドキュメントをlocalStorageに設定します
      setDocumentLocalStorage();
      const url = new URL(`planning/document?${encodedParams}`, marietta.webcad.WebCADGlobal.webcad2Dmanager.lidar_url);
      window.open(url, '_blank');
      const removeDocumentLocalStorage = () => {
        const documentList: AttachmentStorageData[] = storageManager.getItem('attachedDocument');
        if (documentList?.length > 0) {
          const documentIndex = documentList.findIndex((list: AttachmentStorageData) => list.id === params.elementId);
          if (documentIndex > -1) {
            documentList.splice(documentIndex, 1);
          }
        }
        storageManager.setItem('attachedDocument', documentList);
      };
      storageManager.addChangeListener('attachedDocument', (key, newValue: AttachmentStorageData[], oldValue: AttachmentStorageData) => {
        const localStorageData: AttachmentStorageData[] = newValue;
        if (localStorageData && Array.isArray(localStorageData)) {
          const attachmentData = localStorageData.find((list: AttachmentStorageData) => list.id === params.elementId);
          // 情報を設定してリストを更新
          const attachmentList: DocumentCollection[] = attachmentData?.document ?? [];
          this.setDocumentsByGuid(attachmentList, targetGuid, index, type);
          this.createData(true);
          // localStorage からドキュメントを削除します
          removeDocumentLocalStorage();
        }
        storageManager.removeChangeListener('attachedDocument');
      });
    };

    document.querySelectorAll('.btnDocumentsShow')
      .forEach((element: HTMLInputElement) => {
        // ダイアログを表示する
        element.addEventListener('click', (e: MouseEvent) => {
          if ((<HTMLElement>e.target).nodeName.toLowerCase() !== 'button') e.stopPropagation();
          let target: HTMLButtonElement;
          if (e.currentTarget) {
            target = (<HTMLButtonElement>e.currentTarget);
          } else {
            target = (<HTMLButtonElement>e.target);
          }
          const targetGuid = target.getAttribute('data-guid');
          // 情報を設定してリストを更新
          const index = Number(target.getAttribute('data-arrayindex'));
          const type = target.getAttribute('itemtype');
          const documents: DocumentCollection[] = this.getDocumentsByGuid(targetGuid, index, type);
          const param: { documentList: DocumentCollection[], guid: string } = {
            documentList: documents,
            guid: targetGuid,
          };
          const documentListDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.DocumentListDialog, false, true, false, false, param);
        });
      });
    document.querySelectorAll('.btnDocumentsDel')
      .forEach((element: HTMLButtonElement) => {
        element.addEventListener('click', (e: MouseEvent) => {
          if ((<HTMLElement>e.target).nodeName.toLowerCase() !== 'button') e.stopPropagation();
          marietta.webcad.WebCADGlobal.showConfirmDialog('添付資料を削除しますか？', '確認', () => {
            const target: HTMLButtonElement = (<HTMLButtonElement>(<HTMLSpanElement>e.target).parentElement);
            const targetGuid = target.getAttribute('data-guid');
            // 情報を設定してリストを更新
            const index = Number(target.getAttribute('data-arrayindex'));
            const type = target.getAttribute('itemtype');
            this.setDocumentsByGuid(null, targetGuid, index, type);
            this.createData(true);

            // LocalStorageにあれば削除
            const storageManager = new LocalStorageManager();
            const documentList: AttachmentStorageData[] = storageManager.getItem('attachedDocument');
            if (documentList?.length > 0) {
              const documentIndex = documentList.findIndex((list: AttachmentStorageData) => list.id === targetGuid);
              if (documentIndex > -1) {
                documentList.splice(documentIndex, 1);
              }
            }
            storageManager.setItem('attachedDocument', documentList);
          });
        });
      });

    // シェアモードでは値の確認のみとするため、入力・ボタンを無効化する
    // （表はモード切り替えや更新のたびに作り直されるため、イベント設定と同じタイミングで行う）
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
      document.querySelectorAll('#quotationListTable input, #quotationListTable select, #quotationListTable button')
        .forEach((element) => {
          (<HTMLInputElement>element).disabled = true;
        });
    }
  };

  setDocumentsByGuid(attachmentList: DocumentCollection[], targetGuid: string, index: number, type: string): void {
    let targetItem: marietta.webcad.item.MonicaObject = null;
    switch (type) {
      case '壁':
      case '∟巾木':
        if (type === '壁') {
          const targetDot: PointCollection = (this.wallList[index] as marietta.webcad.item.parts.Wall).parentObj.itemInfo.dotList.find((data) => data.guid === targetGuid);
          targetDot.wall_documents = attachmentList;
        } else {
          const guid = targetGuid.replace('_habaki', '');
          const targetDot: PointCollection = (this.wallList[index] as marietta.webcad.item.parts.Wall).parentObj.itemInfo.dotList.find((data) => data.guid === guid);
          targetDot.habaki_documents = attachmentList;
        }
        break;
      case '床':
      case '天井':
        if (type === '床') {
          const guid = targetGuid.replace('_floor', '');
          targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(guid);
          if (targetItem) targetItem.itemInfo.floor_documents = attachmentList;
        } else {
          const guid = targetGuid.replace('_ceiling', '');
          targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(guid);
          if (targetItem) targetItem.itemInfo.ceiling_documents = attachmentList;
        }
        break;
      default:
      case '柱':
        targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(targetGuid);
        if (targetItem) targetItem.itemInfo.documents = attachmentList;
        break;
    }
  }

  getDocumentsByGuid(targetGuid: string, index: number, type: string): DocumentCollection[] {
    let targetItem: marietta.webcad.item.MonicaObject = null;
    let documents: DocumentCollection[] = [];
    switch (type) {
      case '壁':
      case '∟巾木': {
        if (type === '壁') {
          const targetDot: PointCollection = (this.wallList[index] as marietta.webcad.item.parts.Wall).parentObj.itemInfo.dotList.find((data) => data.guid === targetGuid);
          documents = targetDot?.wall_documents ?? [];
        } else {
          const guid = targetGuid.replace('_habaki', '');
          const targetDot: PointCollection = (this.wallList[index] as marietta.webcad.item.parts.Wall).parentObj.itemInfo.dotList.find((data) => data.guid === guid);
          documents = targetDot?.habaki_documents ?? [];
        }
        break;
      }
      case '床':
      case '天井':
        if (type === '床') {
          const guid = targetGuid.replace('_floor', '');
          targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(guid);
          documents = targetItem?.itemInfo.floor_documents ?? [];
        } else {
          const guid = targetGuid.replace('_ceiling', '');
          targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(guid);
          documents = targetItem?.itemInfo.ceiling_documents ?? [];
        }
        break;
      default:
      case '柱':
        targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(targetGuid);
        documents = targetItem?.itemInfo.documents ?? [];
        break;
    }
    return documents;
  }

  /**
   *
   */
  public unselectedAll() {
    $('.itemListContainer')
      .removeClass('selected');
    ThreeView.get()
      .wallEffect
      .unselect();
  }

  /**
   * リスト選択時
   */
  handleSelection = (e: MouseEvent & TouchEvent) => {
    if ((<HTMLElement>e.target).nodeName.toLowerCase() === 'button') return;
    // 3Dモードなら
    const type = (<HTMLInputElement>e.currentTarget).getAttribute('itemtype');
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      let guid = (<HTMLInputElement>e.currentTarget).getAttribute('id');
      guid = guid.split('_')[1];

      // テキストボックスであれば何もしない
      if ((<HTMLInputElement>e.target).getAttribute('class') == 'quote_textbox' || e.target) {
        return;
      }

      console.assert(guid, 'GUIDが正しく設定されていません!!!!');

      const findObjectFromGUID = (guid: string): THREE.Object3D[] => {
        const objects: THREE.Object3D[] = [];
        ThreeView.get()
          .wcScene
          .me
          .traverse((object: THREE.Object3D) => {
            if (object.userData.guid === guid || object.userData.modelInfo && object.userData.modelInfo.uuid === guid) {
              objects.push(object);
            }
          });
        console.log(`${guid} : 複数の形状で同じGUIDが割り当てられています。`);
        return objects;
      };

      if (type === '壁' || type === '柱' || type === '∟巾木') {
        ThreeView.get()
          .wallEffect
          .select(guid);
      } else if (type === '天井') {
        ThreeView.get()
          .wallEffect
          .select(guid, ObjectType.isCeiling);
      } else if (type === '梁') {
        ThreeView.get()
          .wallEffect
          .select(guid, ObjectType.isGirder);
      } else {
        const objects = findObjectFromGUID(guid);
        if (objects.length > 0) {
          if (type === '床') {
            ThreeView.get()
              .wallEffect
              .select(guid, ObjectType.isMitumoriFloor);
          } else {
            ThreeView.get()
              .selectObject(objects[0]);
          }
        }
      }
    } else {
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
        return;
      }
      const index = Number((<HTMLInputElement>e.currentTarget).getAttribute('data-arrayindex'));
      const floor = Number((<HTMLInputElement>e.currentTarget).getAttribute('data-floor'));
      let guid = (<HTMLInputElement>e.currentTarget).getAttribute('id');
      guid = guid.substring(guid.indexOf('_') + 1);
      if (floor !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
        marietta.webcad.WebCADGlobal.changeFloor(floor);
      }
      let targetItem: marietta.webcad.item.MonicaObject = null;
      if (type === '壁' || type === '∟巾木') {
        targetItem = (this.wallList[index] as marietta.webcad.item.parts.Wall).parentObj;
      } else {
        targetItem = marietta.webcad.WebCADGlobal.getItemByGuid(guid);
      }
      if (targetItem != null) {
        marietta.webcad.view.QuotationItemList.pauseQuotationSink = true;
        if (type === '壁' || type === '∟巾木') {
          const wall = this.wallList[index] as marietta.webcad.item.parts.Wall;
          marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
          marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
          marietta.webcad.WebCADGlobal.itemManager.addWalls([wall]);
        } else {
          marietta.webcad.WebCADGlobal.itemManager.currentItem = targetItem;
        }
        marietta.webcad.view.QuotationItemList.pauseQuotationSink = false;
      }
    }

    this.selectRow(e.currentTarget as HTMLElement);
  };

  /**
   * 付帯工事テーブル行選択時
   * フロアが異なれば切り替え、紐づくピンを選択状態にする
   */
  handleAuxiliarySelection = (e: MouseEvent & TouchEvent) => {
    if ((<HTMLElement>e.target).nodeName.toLowerCase() === 'button') return;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) return;

    const rowId = (<HTMLElement>e.currentTarget).getAttribute('id') || '';
    const guid = rowId.substring(rowId.indexOf('_') + 1);
    const parentPin = this.tableDataAuxiliary?.find((d) => d.guid === guid)?.parentPin;

    if (parentPin) {
      const pinFloor = parentPin.itemInfo.floor;
      if (pinFloor !== undefined && pinFloor !== marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
        marietta.webcad.WebCADGlobal.changeFloor(pinFloor);
      }
      marietta.webcad.view.QuotationItemList.pauseQuotationSink = true;
      marietta.webcad.WebCADGlobal.itemManager.currentItem = parentPin;
      marietta.webcad.view.QuotationItemList.pauseQuotationSink = false;
    }

    this.selectRow(e.currentTarget as HTMLElement);
  };

  /**
   * ダイアログを閉じ、指定行をハイライトする共通後処理
   */
  private selectRow(row: HTMLElement): void {
    if (marietta.webcad.WebCADGlobal.currentDialog) {
      marietta.webcad.WebCADGlobal.currentDialog.close();
    }
    $('.itemListContainer').removeClass('selected');
    row.classList.add('selected');
  }

  static pauseQuotationSink: boolean = false;

  /**
   * 対象の部屋のすべてのパーツのチェックボックスをオンにします
   * @param targets
   * @param wall
   * @param floor
   * @param ceiling
   * @param habaki
   */
  public checkTargetRoomParts(targets: MonicaObject[], wall: boolean, floor: boolean, ceiling: boolean, habaki: boolean) {
    for (const target of targets) {
      let element = document.querySelector(`#quotationListTable tr[data-id="area_${target.itemInfo.guid}_ceiling"]`);
      if (element) {
        (<HTMLInputElement>element.closest('tr.itemListContainerArea')
          .querySelector('.quote_check')).checked = ceiling;
        if (this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.guid}_ceiling`)) this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.guid}_ceiling`).is_quote = ceiling;
      }
      element = document.querySelector(`#quotationListTable tr[data-id="area_${target.itemInfo.guid}_floor"]`);
      if (element) {
        (<HTMLInputElement>element.closest('tr.itemListContainerArea')
          .querySelector('.quote_check')).checked = floor;
        if (this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.guid}_floor`)) this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.guid}_floor`).is_quote = floor;
      }
      for (let i = 0; i < target.itemInfo.dotList.length; i += 1) {
        element = document.querySelector(`#quotationListTable tr[data-id="area_${target.itemInfo.dotList[i].guid}"]`);
        if (element) {
          (<HTMLInputElement>element.closest('tr.itemListContainerArea')
            .querySelector('.quote_check')).checked = wall;
          if (this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.dotList[i].guid}`)) this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.dotList[i].guid}`).is_quote = wall;
        }
      }
      for (let i = 0; i < target.itemInfo.dotList.length; i += 1) {
        element = document.querySelector(`#quotationListTable tr[data-id="area_${target.itemInfo.dotList[i].guid}_habaki"]`);
        if (element) {
          (<HTMLInputElement>element.closest('tr.itemListContainerArea')
            .querySelector('.quote_check')).checked = habaki;
          if (this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.dotList[i].guid}_habaki`)) this.tableDataQuotation.find((d) => d.guid === `${target.itemInfo.dotList[i].guid}_habaki`).is_quote = habaki;
        }
      }
    }
  }

  /**
   * アイテム選択
   */
  public highlightQuotationItemList(target: MonicaObject = null, type: string = null) {
    // 見積一覧クリック→カレント更新→highlightQuotationItemListの場合は、リストが変なところにスクロールするので、実施しない
    if (marietta.webcad.view.QuotationItemList.pauseQuotationSink) {
      return;
    }

    $('.itemListContainer')
      .removeClass('selected');
    const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
    const matrix = new WebKitCSSMatrix(style.transform);
    // if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
    //   return;
    // }
    // if (marietta.webcad.WebCADGlobal.itemManager.currentItem == null) {
    //   return;
    // }

    const wallItems = this.highlightWalls();
    // 壁アイテムのハイライト
    this.highlightCurrentWall(wallItems, matrix);

    if (target == null && marietta.webcad.WebCADGlobal.itemManager.currentItem == null) {
      return;
    }
    if (target == null) target = marietta.webcad.WebCADGlobal.itemManager.currentItem;
    // const item = marietta.webcad.WebCADGlobal.itemManager.currentItem;
    const item = target;
    let element;
    switch (item.itemInfo.id.substring(0, 3)) {
      case 'rom':
        if (this.mode !== 1) {
          this.mode = 1;
          $('input[name=checkInputMode][value="1"]')
            .prop('checked', true);
          this.createTable(this.mode);
        }
        if (type == null) {
          element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_ceiling"]`);
          if (element) {
            element.classList.add('selected');
            this.scrollToList(element);
          }
          element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_floor"]`);
          if (element) {
            element.classList.add('selected');
            this.scrollToList(element);
          }
          for (let i = 0; i < item.itemInfo.dotList.length; i += 1) {
            element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.dotList[i].guid}"]`);
            if (element) {
              element.classList.add('selected');
              this.scrollToList(element);
            }
            element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.dotList[i].guid}_habaki"]`);
            if (element) {
              element.classList.add('selected');
              this.scrollToList(element);
            }
          }
        } else {
          switch (type) {
            case 'wall':
              for (let i = 0; i < item.itemInfo.dotList.length; i += 1) {
                element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.dotList[i].guid}"]`);
                if (element) {
                  element.classList.add('selected');
                  this.scrollToList(element);
                }
                element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.dotList[i].guid}_habaki"]`);
                if (element) {
                  element.classList.add('selected');
                  this.scrollToList(element);
                }
              }
              break;
            case 'floor':
              element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_floor"]`);
              if (element) {
                element.classList.add('selected');
                this.scrollToList(element);
              }
              break;
            case 'ceiling':
              element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_ceiling"]`);
              if (element) {
                element.classList.add('selected');
                this.scrollToList(element);
              }
              break;
            case 'floor-ceiling':
              element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_ceiling"]`);
              if (element) element.classList.add('selected');
              element = document.querySelector(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}_floor"]`);
              if (element) {
                element.classList.add('selected');
                this.scrollToList(element);
              }
              break;
            default:
              break;
          }
        }
        break;
      case 'col':
        if (this.mode !== 1) {
          this.mode = 1;
          $('input[name=checkInputMode][value="1"]')
            .prop('checked', true);
          this.createTable(this.mode);
        }
        element = document.querySelectorAll(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      case 'bem':
        if (this.mode !== QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO) {
          this.mode = QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO;
          $(`input[name=checkInputMode][value="${QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO}"]`)
            .prop('checked', true);
          this.createTable(this.mode);
        }
        element = document.querySelectorAll(`#quotationListTable tr[data-id="area_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      case 'fit':
        if (this.mode !== QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO) {
          this.mode = QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO;
          $(`input[name=checkInputMode][value="${QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO}"]`)
            .prop('checked', true);
          this.createTable(this.mode);
        }
        element = document.querySelectorAll(`#quotationListTable tr[data-id="fitting_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      case 'equ':
      case 'fur':
        if (this.mode !== QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO) {
          this.mode = QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO;
          $(`input[name=checkInputMode][value="${QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO}"]`)
            .prop('checked', true);
          this.createTable(this.mode);
        }
        element = document.querySelectorAll(`#quotationListTable tr[data-id="equipment_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      case 'ext':
        if (this.mode !== QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO) {
          this.mode = QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO;
          $(`input[name=checkInputMode][value="${QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO}"]`)
            .prop('checked', true);
          this.createTable(this.mode);
        }
        element = document.querySelectorAll(`#quotationListTable tr[data-id="exterior_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      case 'txt':
        if (this.mode !== QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO) {
          this.mode = QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO;
          $(`input[name=checkInputMode][value="${QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO}"]`)
            .prop('checked', true);
          this.createAuxiliaryTable(this.mode);
        }

        element = document.querySelectorAll(`#quotationListTable tr[data-id="auxiliary_${item.itemInfo.guid}"]`);
        for (let i = 0; i < element.length; i += 1) {
          element[i].classList.add('selected');
          this.scrollToList(element[i]);
        }
        break;
      default:
        break;
    }
  }

  /**
   * 壁 リストをハイライト
   * @param wallItems
   * @param matrix
   */
  private highlightCurrentWall(wallItems: marietta.webcad.item.parts.Wall[], matrix: DOMMatrix) {
    if (wallItems.length > 0) {
      if (this.mode !== 1) {
        this.mode = 1;
        $('input[name=checkInputMode][value="1"]')
          .prop('checked', true);
        this.createTable(this.mode);
      }
      wallItems.forEach((wall) => {
        let { guid } = wall.parentObj.itemInfo.dotList[wall.index];
        if (wall.parentObj instanceof WallObject) {
          guid = wall.parentObjInfo.guid;
        }
        if (marietta.webcad.WebCADGlobal.quotationItemList.wallList) {
          $(`#area_${guid}`)
            .addClass('selected');
          $(`#area_${guid}_habaki`)
            .addClass('selected');
        }
      });
      let { guid } = wallItems[0].parentObj.itemInfo.dotList[wallItems[0].index];
      if (wallItems[0].parentObj instanceof WallObject) {
        guid = wallItems[0].parentObjInfo.guid;
      }
      const element = document.querySelector(`#quotationListTable tr[data-id="area_${guid}"]`);
      if (element) {
        this.scrollToList(element);
      }
    }
  }

  /**
   * 要素にスクロール
   */
  private scrollToList(element: Element): void {
    if (!element) return;
    const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
    const matrix = new WebKitCSSMatrix(style.transform);
    if (matrix.m42 === 15) {
      if (element.getAttribute('id') && document.getElementById(element.getAttribute('id'))) {
        (document.getElementById(element.getAttribute('id'))).scrollIntoView(false);
      }
    }
    // if (!element) return;

    // const rect = element.getBoundingClientRect();
    // setTimeout(() => {
    //   if (element.getAttribute('id') && document.getElementById(element.getAttribute('id'))) {
    //       (document.getElementById(element.getAttribute('id')).parentElement).scrollTo(0, rect.top);
    //     }
    //   }, 2);
  }

  /**
   * アイテム選択
   */
  public highlightQuotationItemByIDList(parent: MonicaObject, target: string, type: string = null) {
    // 表示中のタブに対象の行がないとハイライトできないため、先に対象のタブへ切り替える
    const mode: number = parent instanceof Fitting
      ? QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO
      : QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO;
    if (this.mode !== mode) {
      this.mode = mode;
      $(`input[name=checkInputMode][value="${mode}"]`)
        .prop('checked', true);
      this.createTable(this.mode);
    }

    $('.itemListContainer')
      .removeClass('selected');
    const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));

    let element;
    if (parent instanceof Fitting) {
      element = document.querySelector(`#quotationListTable tr[data-id="fitting_${target}"]`);
    } else {
      element = document.querySelector(`#quotationListTable tr[data-id="area_${target}"]`);
    }

    if (element) {
      element.classList.add('selected');

      this.scrollToList(element);
    }
  }

  /**
   * 見積参入の適用
   */
  public setIsQuoteInData(guid:string, value:boolean){
    const data = this.tableDataQuotation.find((d) => d.guid === guid);
    if (data) {
      data.is_quote = value;
    }
  };

  /**
   * 見積一覧表の行のチェックボックスをクリック
   * @param e
   */
  onQuoteCheck = (e: Event) => {
    const guid = (<HTMLInputElement>e.currentTarget).getAttribute('data-guid');
    const data = this.tableDataQuotation.find((d) => d.guid === guid);
    if (data) {
      data.is_quote = (<HTMLInputElement>e.currentTarget).checked;
    }

    this.updateValue(e);
  };

  /**
   * すべての見積もりリストを確認する
   * @param e
   */
  onQuoteCheckAll = (e: Event) => {
    const mode = Number(document.querySelector('input[name="checkInputMode"]:checked')
      .getAttribute('value'));// Number(document.querySelector('input[name="checkInputMode"]:checked').getAttribute('value'));
    // ステータス取得
    const isChecked: boolean = (<HTMLInputElement>document.getElementById('quotationAllSelectCheckbox')).checked;

    switch (mode) {
      case QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO:
        if (this.tableDataWall && Array.isArray(this.tableDataWall)) {
          const itemType = '';
          this.tableDataWall = this.tableDataWall.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        if (this.tableDataHabaki && Array.isArray(this.tableDataHabaki)) {
          const itemType = '';
          this.tableDataHabaki = this.tableDataHabaki.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        if (this.tableDataFloor && Array.isArray(this.tableDataFloor)) {
          this.tableDataFloor = this.tableDataFloor.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"][itemType="'+ itemType +'"].quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        if (this.tableDataCeiling && Array.isArray(this.tableDataCeiling)) {
          this.tableDataCeiling = this.tableDataCeiling.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"][itemType="'+ itemType +'"].quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        if (this.tableDataBeam && Array.isArray(this.tableDataBeam)) {
          this.tableDataBeam = this.tableDataBeam.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        if (this.tableDataColumn && Array.isArray(this.tableDataColumn)) {
          this.tableDataColumn = this.tableDataColumn.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        break;
      case QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO:
        if (this.tableDataFitting && Array.isArray(this.tableDataFitting)) {
          this.tableDataFitting = this.tableDataFitting.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        break;

      case QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO:
        if (this.tableDataEquipment && Array.isArray(this.tableDataEquipment)) {
          this.tableDataEquipment = this.tableDataEquipment.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        break;

      case QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO:
        if (this.tableDataExterior && Array.isArray(this.tableDataExterior)) {
          this.tableDataExterior = this.tableDataExterior.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        break;
      case QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO:
        if (this.tableDataAuxiliary && Array.isArray(this.tableDataAuxiliary)) {
          this.tableDataAuxiliary = this.tableDataAuxiliary.map((obj) => {
            // if (obj.end_item_info) {
            obj.is_quote = isChecked;

            //データ適用
            const item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(obj.guid);
            if (item) {
              this.updateAuxiliaryDatum(item as PinPicture, obj, obj.guid, 'is_quote', String(isChecked));
            }
            // (document.getElementById('quotationListData').querySelector('tr[data-mode="'+ mode +'"] .quote_check[data-guid="'+ obj.guid +'"]') as HTMLInputElement).checked = isChecked;
            // }
            return obj;
          });
        }
        break;
      default:
        break;
    }
    // let checkboxList = document.getElementById('quotationListData').querySelectorAll('tr[data-mode="'+ mode +'"][data-enditem="1"] input[type="checkbox"].quote_check');
    const checkboxList = document.getElementById('quotationListData')
      .querySelectorAll(`tr[data-mode="${mode}"] input[type="checkbox"].quote_check`);
    if (checkboxList) {
      checkboxList.forEach((elem) => {
        (elem as HTMLInputElement).checked = isChecked;
      });
    }
  };

  /**
   *
   * @param e
   */
  updateValue = (e: Event) => {
    const guid = (<HTMLInputElement>e.currentTarget).getAttribute('data-guid');
    const property = (<HTMLInputElement>e.currentTarget).getAttribute('data-property');
    const mode = Number.parseInt((<HTMLInputElement>e.currentTarget).getAttribute('data-mode'), 10);
    const data = this.tableDataQuotation.find((d) => d.guid === guid)
      ?? this.tableDataAuxiliary?.find((d) => d.guid === guid);
    if (data) {
      let val = (<HTMLInputElement>e.currentTarget).value;
      // rate（入居者負担割合）の値を0〜100の整数に制限
      if (property === 'rate') {
        const clampedRate = Math.min(100, Math.max(0, Math.round(Number(val))));
        val = String(clampedRate);
        (<HTMLInputElement>e.currentTarget).value = val;
      }
      data[property] = val;
      let item: MonicaObject | marietta.webcad.collection.PointCollection;
      let endItemInfo = null;
      if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_BEAM_TYPE_NO || mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FITTING_TYPE_NO || mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EQUIPMENT_TYPE_NO || mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FURNITURE_TYPE_NO || mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EXTERIOR_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
        if (item) {
          endItemInfo = (item as MonicaObject).itemInfo.end_item_info;
          if (!endItemInfo) {
            endItemInfo = (item as MonicaObject).itemInfo.white_item_info;
            if (!endItemInfo) {
              (item as MonicaObject).itemInfo.white_item_info = new MasterItemCollection();
              endItemInfo = (item as MonicaObject).itemInfo.white_item_info;
            }
          }
        }
      } else if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_CEILING_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid.replace('_ceiling', ''));
        if (item) {
          endItemInfo = (item as MonicaObject).itemInfo.ceiling_end_item_info;
          if (!endItemInfo) {
            endItemInfo = (item as MonicaObject).itemInfo.ceiling_white_item_info;
            if (!endItemInfo) {
              (item as MonicaObject).itemInfo.ceiling_white_item_info = new MasterItemCollection();
              endItemInfo = (item as MonicaObject).itemInfo.ceiling_white_item_info;
            }
          }
        }
      } else if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FLOOR_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid.replace('_floor', ''));
        if (item) {
          endItemInfo = (item as MonicaObject).itemInfo.floor_end_item_info;
          if (!endItemInfo) {
            endItemInfo = (item as MonicaObject).itemInfo.floor_white_item_info;
            if (!endItemInfo) {
              (item as MonicaObject).itemInfo.floor_white_item_info = new MasterItemCollection();
              endItemInfo = (item as MonicaObject).itemInfo.floor_white_item_info;
            }
          }
        }
      } else if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_WALL_TYPE_NO || mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_COLUMN_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.itemManager.getWallByGuid(guid);
        if (item) {
          endItemInfo = (item as marietta.webcad.collection.PointCollection).inner_end_item_info;
          if (!endItemInfo) {
            endItemInfo = (item as marietta.webcad.collection.PointCollection).inner_white_item_info;
            if (!endItemInfo) {
              (item as marietta.webcad.collection.PointCollection).inner_white_item_info = new MasterItemCollection();
              endItemInfo = (item as marietta.webcad.collection.PointCollection).inner_white_item_info;
            }
          }
        }
      } else if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_HABAKI_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.itemManager.getWallByGuid(guid.substring(0, guid.lastIndexOf('_')));
        if (item) {
          endItemInfo = (item as marietta.webcad.collection.PointCollection).habaki_end_item_info;
          if (!endItemInfo) {
            endItemInfo = (item as marietta.webcad.collection.PointCollection).habaki_white_item_info;
            if (!endItemInfo) {
              (item as marietta.webcad.collection.PointCollection).habaki_white_item_info = new MasterItemCollection();
              endItemInfo = (item as marietta.webcad.collection.PointCollection).habaki_white_item_info;
            }
          }
        }
      } else if (mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_AUXILIARY_TYPE_NO) {
        item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
        if (item) {
          this.updateAuxiliaryDatum(item as PinPicture, data, guid, property, val, e.currentTarget as HTMLElement);
        }
      }


      if (item) {
        if (endItemInfo) {
          switch (property) {
            case 'unit':
              endItemInfo.item_unit = val;
              break;
            case 'unit_price':
              endItemInfo.item_unit_price = (!Number.isNaN(parseFloat(val)) ? parseFloat(val) : 0);
              data.price = Math.round(parseFloat(val) * parseFloat(data.area));
              (<HTMLInputElement>e.currentTarget).closest('tr')
                .querySelector('td[data-property="price"]').innerHTML = marietta.webcad.util.WebCADUtil.priceFormat(data.price);
              break;
            case 'maker':
              endItemInfo.item_maker_name = val;
              break;
            case 'part_number':
              endItemInfo.item_part_number = val;
              break;
            case 'note':
              endItemInfo.item_memo = val;
              break;
            case 'item_name':
              endItemInfo.item_name = val;
              break;
            case 'item_sub_category':
              endItemInfo.item_sub_category = val;
              break;
            default:
              break;
          }
        }
      }
    }
  };

  getTypeName(key: number): string {
    let name: string = '';
    switch (key) {
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_WALL_TYPE_NO:
        name = 'wall';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_HABAKI_TYPE_NO:
        name = 'habaki';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FLOOR_TYPE_NO:
        name = 'floor';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_CEILING_TYPE_NO:
        name = 'ceiling';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_BEAM_TYPE_NO:
        name = 'beam';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_COLUMN_TYPE_NO:
        name = 'column';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FITTING_TYPE_NO:
        name = 'fitting';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FURNITURE_TYPE_NO:
        name = 'furniture';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EQUIPMENT_TYPE_NO:
        name = 'equipment';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EXTERIOR_TYPE_NO:
        name = 'exterior';
        break;
      default:
        break;
    }
    return name;
  }

  /**
   * モード番号に基づいて名前を取得
   * @param key
   * @returns
   */
  getModeName(key: number): string {
    let name: string = '';
    switch (key) {
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_WALL_TYPE_NO:
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_HABAKI_TYPE_NO:
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FLOOR_TYPE_NO:
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_CEILING_TYPE_NO:
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_BEAM_TYPE_NO:
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_COLUMN_TYPE_NO:
        name = 'area';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_FITTING_TYPE_NO:
        name = 'fitting';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EQUIPMENT_TYPE_NO:
        name = 'equipment';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_EXTERIOR_TYPE_NO:
        name = 'exterior';
        break;
      case QUOTATION_ITEM_LIST_TYPE_MODE.MODE_AUXILIARY_TYPE_NO:
        name = 'auxiliary';
        break;
      default:
        break;
    }
    return name;
  }

  /**
   * 名前に基づいてモード番号を取得する
   * @returns
   * @param name
   */
  getModeByName(name: string): number {
    let mode: number = 1;
    switch (name) {
      case 'area':
        mode = QUOTATION_ITEM_LIST_MODE.MODE_ROOM_PARTS_LIST_NO;
        break;
      case 'fitting':
        mode = QUOTATION_ITEM_LIST_MODE.MODE_FITTING_LIST_NO;
        break;
      case 'equipment':
      case 'furniture':
        mode = QUOTATION_ITEM_LIST_MODE.MODE_EQUIPMENT_FURNITURE_LIST_NO;
        // mode = QUOTATION_ITEM_LIST_MODE.MODE_FURNITURE_LIST_NO;
        break;
      case 'exterior':
        mode = QUOTATION_ITEM_LIST_MODE.MODE_EXTERIOR_LIST_NO;
        break;
      case 'auxiliary':
        mode = QUOTATION_ITEM_LIST_MODE.MODE_AUXILIARY_LIST_NO;
        break;
      default:
        break;
    }
    return mode;
  }

  /**
   *壁データ
   */
  createRoomParts() {
    this.roomItemList = [];
    this.wallList = [];
    this.tableDataWall = [];
    this.tableDataHabaki = [];
    this.tableDataFloor = [];
    this.tableDataCeiling = [];

    let targetAuxiliary: AuxiliaryConstructionCollection;
    let hasAuxiliary: boolean;
    let includeInQuote: boolean;

    // // 建具リスト
    // const fittingItemList = [];
    // const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    // for (let floor = 1; floor <= highestFloor; floor++) {
    //   fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_FITTING_NO)).getAllChildren());
    //   fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_FITTINGDOWN1_NO)).getAllChildren());
    // }

    // 部屋アイテム
    let itemList: marietta.webcad.item.Room[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);

    // 見積に含めないアイテムを除外する
    for (let i: number = itemList.length - 1; i >= 0; i -= 1) {
      switch ((itemList[i] as Room).itemInfo.id.substring(0, 5)) {
        case 'rom36':
        case 'rom37':
          itemList.splice(i, 1);
          break;
      }
    }

    this.roomItemList = itemList;

    for (let i: number = 0; i < this.roomItemList.length; i += 1) {
      const info: ItemInfoCollection = (this.roomItemList[i] as Room).itemInfo;

      const walls: Wall[] = (this.roomItemList[i] as Room).wallObjList;
      let data = this.tableDataQuotation.find((d) => d.guid === `${info.guid}_floor`);
      const area = marietta.webcad.util.WebCADUtil.calculateArea(info.dotList, false);

      let dataToReferTo: MasterItemCollection = info.floor_end_item_info;
      if (!dataToReferTo) {
        if (info.floor_white_item_info) dataToReferTo = info.floor_white_item_info;
      }
      if (dataToReferTo) dataToReferTo.symbol_2d_code = 'flooring';

      hasAuxiliary = AuxiliaryUtil.hasAuxiliaryWithCheckOn(`${info.guid}_floor`);
      includeInQuote = data?.is_quote;
      //STARTS_LIDAR-2029 見積画面への付帯工事が紐づけられているアイテムの非表示化
      //付帯工事がONであれば、親工事をONにする処理はOFF
      // if (hasAuxiliary) includeInQuote = true;

      const floor: QuotationListCollection = new QuotationListCollection();

      floor.arrayIndex = i;
      floor.is_quote = includeInQuote;
      floor.name = '床';
      floor.floor = info.floor;
      floor.width = '-';
      floor.depth = '-';
      floor.height = '-';
      floor.area = area.toFixed(3);
      floor.unit = '㎡';
      floor.maker = (dataToReferTo) ? dataToReferTo.item_maker_name : '';
      floor.part_number = (dataToReferTo) ? dataToReferTo.item_part_number : '';
      floor.item_set_date = (data && data.item_set_date) ? data.item_set_date : ((marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date) ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
      floor.note = (dataToReferTo) ? dataToReferTo.item_memo : '';
      floor.documents = info.floor_documents;
      floor.item_name = (dataToReferTo) ? dataToReferTo.item_name : '';
      floor.item_sub_category = (dataToReferTo) ? dataToReferTo.item_sub_category : '';
      floor.unit_price = (dataToReferTo) ? dataToReferTo.item_unit_price : '-';
      floor.price = (dataToReferTo) ? Math.round((dataToReferTo.item_unit_price * area)) : '-';
      floor.guid = `${info.guid}_floor`;
      floor.room_name = info.text.length ? info.text : '（空白）';
      floor.item_id = (dataToReferTo) ? dataToReferTo.item_id : '-';
      floor.end_item_info = (dataToReferTo) || null;
      this.tableDataFloor.push(floor);

      dataToReferTo = info.ceiling_end_item_info;
      if (!dataToReferTo) {
        if (info.ceiling_white_item_info) dataToReferTo = info.ceiling_white_item_info;
      }
      if (dataToReferTo) dataToReferTo.symbol_2d_code = 'wallpaper';

      data = this.tableDataQuotation.find((d) => d.guid === `${info.guid}_ceiling`);

      hasAuxiliary = AuxiliaryUtil.hasAuxiliaryWithCheckOn(`${info.guid}_ceiling`);
      includeInQuote = data?.is_quote;
      //STARTS_LIDAR-2029 見積画面への付帯工事が紐づけられているアイテムの非表示化
      //付帯工事がONであれば、親工事をONにする処理はOFF
      // if (hasAuxiliary) includeInQuote = true;

      const ceiling: QuotationListCollection = new QuotationListCollection();
      ceiling.arrayIndex = i;
      ceiling.is_quote = includeInQuote;
      ceiling.name = '天井';
      ceiling.floor = info.floor;
      ceiling.width = '-';
      ceiling.depth = '-';
      ceiling.height = '-';
      ceiling.area = area.toFixed(3);
      ceiling.unit = '㎡';
      ceiling.maker = (dataToReferTo) ? dataToReferTo.item_maker_name : '';
      ceiling.part_number = (dataToReferTo) ? dataToReferTo.item_part_number : '';
      ceiling.item_name = (dataToReferTo) ? dataToReferTo.item_name : '';
      ceiling.item_sub_category = (dataToReferTo) ? dataToReferTo.item_sub_category : '';
      ceiling.unit_price = (dataToReferTo) ? dataToReferTo.item_unit_price : '-';
      ceiling.price = (dataToReferTo) ? Math.round(dataToReferTo.item_unit_price * area) : '-';
      ceiling.item_set_date = data && data.item_set_date ? data.item_set_date : (marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
      ceiling.note = (dataToReferTo) ? dataToReferTo.item_memo : '';
      ceiling.documents = info.ceiling_documents;
      ceiling.guid = `${info.guid}_ceiling`;
      ceiling.room_name = info.text.length ? info.text : '（空白）';
      ceiling.item_id = (dataToReferTo) ? dataToReferTo.item_id : '-';
      ceiling.end_item_info = (dataToReferTo) || null;
      this.tableDataCeiling.push(ceiling);

      this.wallList = this.wallList.concat(walls);
    }
    const wallObjList = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
    for (let i: number = 0; i < wallObjList.length; i += 1) {
      this.wallList.push(wallObjList[i].wallObjList[0]);
    }

    // //壁一覧を更新しておく
    // marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();

    // 建具の下の壁は、壁ごとに求めると「壁 × 建具」回になって重いので、建具ごとに 1 回だけ求める
    const wallsBeneathFitting: Map<Fitting, Wall[]> = new Map();
    const getWallsBeneath = (fitting: Fitting): Wall[] => {
      if (!wallsBeneathFitting.has(fitting)) wallsBeneathFitting.set(fitting, fitting.getWallsBeneath());
      return wallsBeneathFitting.get(fitting);
    };

    for (let i: number = 0; i < this.wallList.length; i += 1) {
      const wall = this.wallList[i];

      // 開口は、含めない
      if (wall.wallType === 0) {
        continue;
      }

      // 重なっている建具の面積を集計
      let fittingArea = 0;
      // 建具リスト
      const fittingItemList = [];
      fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(wall.parentObj.itemInfo.floor, ITEM_MODE_NO.MODE_FITTING_NO)).getAllChildren());
      fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(wall.parentObj.itemInfo.floor, ITEM_MODE_NO.MODE_FITTINGDOWN1_NO)).getAllChildren());

      // console.log(wall.parentObj.itemInfo.floor, wall.parentObj.itemInfo.text);
      // if (wall.parentObj.itemInfo.floor === 2 && wall.parentObj.itemInfo.text === '廊下') console.log(fittingItemList);
      for (let k = 0; k < fittingItemList.length; k += 1) {
        if (!this.wallList[i].hasOwnProperty('_startDot')) {
          console.warn('見積リスト生成で、startDotが未定義です。処理を見直してください');
          continue;
        }
        const beneathList: marietta.webcad.item.parts.Wall[] = getWallsBeneath(fittingItemList[k]);
        for (let n = 0; n < beneathList.length; n += 1) {
          // console.log( beneathList[n].startDot, wall.startDot )
          if (beneathList[n].startDot.guid === wall.startDot.guid) {
            fittingArea += fittingItemList[k].itemInfo.area;
            // console.log(fittingItemList[k].itemInfo.area, fittingArea);
          }
        }

        // if (wall.parentObj.itemInfo.floor === 2 && wall.parentObj.itemInfo.text === '廊下') console.log(beneathList);
      }

      const data = this.tableDataQuotation.find((d) => d.guid === wall.startDot.guid);
      if (!wall.parentObj) {
        console.warn('見積リスト生成で、wall.parentObjが未定義です。処理を見直してください');
        continue;
      }
      const floorInfo = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeightOfFloor(wall.parentObj.itemInfo.floor);
      const hasHabaki: boolean = marietta.webcad.WebCADGlobal.isRoomWithHabaki(wall.parentObj.itemInfo.id);
      const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
      const habakiH: number = wall.parentObj.itemInfo.habaki_height; // hasHabaki ? jsonData.height.habaki_height : 0;

      const width = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(wall.startDot.point, wall.endDot.point)));
      const height = floorInfo.ceilingHeight - floorInfo.floorHeight - habakiH - wall.parentObj.itemInfo.ceiling_hang_height;
      const wallIndex: number = wall.index;
      let wall_end_item_info: MasterItemCollection = wall.parentObj.itemInfo.dotList[wallIndex].inner_end_item_info;
      if (!wall_end_item_info) {
        if (wall.parentObj.itemInfo.dotList[wallIndex].inner_white_item_info) wall_end_item_info = wall.parentObj.itemInfo.dotList[wallIndex].inner_white_item_info;
      }
      if (wall_end_item_info) wall_end_item_info.symbol_2d_code = 'wallpaper';

      let area = (parseFloat(((width / 1000) * (height / 1000)).toFixed(2)) - fittingArea).toFixed(3);
      if ((parseFloat(((width / 1000) * (height / 1000)).toFixed(2)) - fittingArea) < 0) area = '0'; // 建具面積が壁面積を上回る場合は0にする

      hasAuxiliary = AuxiliaryUtil.hasAuxiliaryWithCheckOn(wall.startDot.guid);
      includeInQuote = data?.is_quote;
      //STARTS_LIDAR-2029 見積画面への付帯工事が紐づけられているアイテムの非表示化
      //付帯工事がONであれば、親工事をONにする処理はOFF
      // if (hasAuxiliary) includeInQuote = true;

      const wallData: QuotationListCollection = new QuotationListCollection();
      wallData.arrayIndex = i;
      wallData.is_quote = includeInQuote;
      wallData.name = '壁';
      wallData.floor = wall.parentObj.itemInfo.floor;
      wallData.width = width;
      wallData.depth = '-';
      wallData.height = height;
      wallData.area = area;

      // STARTS_LIDAR-1869 見積もり機能：内部処理の仕様変更 単位の修正
      wallData.unit = '㎡';// (wall_end_item_info) ? wall_end_item_info.item_unit : '-';
      wallData.maker = (wall_end_item_info) ? wall_end_item_info.item_maker_name : '';
      wallData.part_number = (wall_end_item_info) ? wall_end_item_info.item_part_number : '';
      wallData.item_name = (wall_end_item_info) ? wall_end_item_info.item_name : '';
      wallData.item_sub_category = (wall_end_item_info) ? wall_end_item_info.item_sub_category : '';
      wallData.unit_price = (wall_end_item_info) ? wall_end_item_info.item_unit_price : '-';
      wallData.price = (wall_end_item_info) ? Math.round(wall_end_item_info.item_unit_price * Number.parseFloat(area)) : '-';
      wallData.item_set_date = (data && data.item_set_date) ? data.item_set_date : ((marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date) ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
      wallData.note = (wall_end_item_info) ? wall_end_item_info.item_memo : '';
      wallData.documents = wall.parentObj.itemInfo.dotList[wallIndex].wall_documents;
      wallData.guid = wall.startDot.guid;
      wallData.room_name = wall.parentObj instanceof Room ? (wall.parentObj.itemInfo.text.length ? wall.parentObj.itemInfo.text : '（空白）') : '';
      wallData.item_id = (wall_end_item_info) ? wall_end_item_info.item_id : '-';
      wallData.end_item_info = (wall_end_item_info) || null;
      wallData.item = (<MonicaObject>wall.parentObj);

      this.tableDataWall.push(wallData);

      if (hasHabaki) {
        let { habaki_end_item_info } = wall.parentObj.itemInfo.dotList[wallIndex];
        if (!habaki_end_item_info) {
          if (wall.parentObj.itemInfo.dotList[wallIndex].habaki_white_item_info) habaki_end_item_info = wall.parentObj.itemInfo.dotList[wallIndex].habaki_white_item_info;
        }
        if (habaki_end_item_info) habaki_end_item_info.symbol_2d_code = 'habaki';

        // 巾木
        const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
        const infoHabaki: HabakInfo = {
          index: i,
          itemInfo: wall.parentObj.itemInfo,
          habaki_guid: `${wall.startDot.guid}_habaki`,
          parentItem: wall.parentObj as MonicaObject,
          width,
          height: habakiH,
          habaki_end_item_info,
          habaki_documents: wall.parentObj.itemInfo.dotList[wallIndex].habaki_documents,
          price: '-',
          room_name: wall.parentObj instanceof Room ? (wall.parentObj.itemInfo.text.length ? wall.parentObj.itemInfo.text : '（空白）') : '',
        };
        const habakiData: QuotationListCollection = this.createHabakiData(infoHabaki);

        // const habaki_guid = `${wall.startDot.guid}_habaki`;
        // const data2 = this.tableDataQuotation.find((d) => (d.guid === habaki_guid && d.name.indexOf('巾木') > -1));
        //
        // const habakiData:QuotationListCollection = new QuotationListCollection();
        // habakiData.arrayIndex = i;
        // habakiData.is_quote = data2 ? data2.is_quote : false;
        // habakiData.name = '∟巾木';
        // habakiData.floor = wall.parentObj.itemInfo.floor;
        // habakiData.width = width;
        // habakiData.depth = '-';
        // habakiData.height = habakiH;
        // habakiData.area = width.toString(10), // (parseFloat(((width / 1000) * (50 / 1000)).toFixed(2))).toFixed(3);
        // habakiData.unit = 'mm'; // (habaki_end_item_info)?habaki_end_item_info.item_unit:'-';
        // habakiData.maker = (habaki_end_item_info) ? habaki_end_item_info.item_maker_name : '';
        // habakiData.part_number = (habaki_end_item_info) ? habaki_end_item_info.item_part_number : '-';
        // habakiData.item_name = (habaki_end_item_info) ? habaki_end_item_info.item_name : '';
        // habakiData.item_sub_category = (habaki_end_item_info) ? habaki_end_item_info.item_sub_category : '-';
        // habakiData.unit_price = (habaki_end_item_info) ? habaki_end_item_info.item_unit_price : '-';
        // habakiData.price = (habaki_end_item_info) ? Math.round(habaki_end_item_info.item_unit_price * Number.parseFloat(area)) : '-';
        // habakiData.item_set_date = (data2 && data2.item_set_date) ? data2.item_set_date : ((marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date) ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
        // habakiData.note = (habaki_end_item_info) ? habaki_end_item_info.item_memo : '';
        // habakiData.documents = wall.parentObj.itemInfo.dotList[wallIndex].habaki_documents;
        // habakiData.guid = `${wall.startDot.guid}_habaki`;
        // habakiData.room_name = wall.parentObj instanceof Room ? (wall.parentObj.itemInfo.text.length ? wall.parentObj.itemInfo.text : '（空白）') : '';
        // habakiData.item_id = (habaki_end_item_info) ? habaki_end_item_info.item_id : '-';
        // habakiData.end_item_info = (habaki_end_item_info) || null;
        // habakiData.isHabaki = true; // tableDataWallに巾木のデータが入っているようなのでフラグを追;
        // habakiData.item =(<MonicaObject>wall.parentObj);

        this.tableDataWall.push(habakiData);
      }
    }
    this.createBeam();
    this.createColumn();
  }

  /**
   *梁データ
   */
  createBeam() {
    this.beamItemList = [];
    this.tableDataBeam = [];
    const heighestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let floor = 1; floor <= heighestFloor; floor++) {
      this.beamItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_BEAM_NO)).getAllChildren());
    }
    for (let i: number = 0; i < this.beamItemList.length; i += 1) {
      const info: ItemInfoCollection = (this.beamItemList[i] as MonicaObject).itemInfo;
      const data = this.tableDataQuotation.find((d) => d.guid === info.guid);
      const pushData: QuotationListCollection = this.createDataObject(i, 'beam', data, info);

      // STARTS_LIDAR-1869 見積もり機能：内部処理の仕様変更 単位の修正
      pushData.width = pushData.depth = pushData.height = '-';
      pushData.area = '-';
      pushData.unit = '㎡';// (wall_end_item_info) ? wall_end_item_info.item_unit : '-';
      this.tableDataBeam.push(pushData);
    }
  }

  /**
   *柱データ
   */
  createColumn() {
    this.columnItemList = [];
    this.tableDataColumn = [];
    const heighestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let floor = 1; floor <= heighestFloor; floor++) {
      this.columnItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_COLUMN_NO)).getAllChildren());
    }

    let hasAuxiliary: boolean;
    let includeInQuote: boolean;

    for (let i: number = 0; i < this.columnItemList.length; i += 1) {
      // const info: ItemInfoCollection = (this.columnItemList[i] as MonicaObject).itemInfo;
      // const data = this.tableDataQuotation.find(d => d.guid === info.guid);
      // let pushData:QuotationListCollection = this.createDataObject( i, "column", data, info );
      // this.tableDataColumn.push(pushData);

      const info: ItemInfoCollection = (this.columnItemList[i] as MonicaObject).itemInfo;

      for (let k: number = 0; k < info.dotList.length; k += 1) {
        const data = this.tableDataQuotation.find((d) => d.guid === info.dotList[k].guid);
        const startPoint = k;
        const endPoint = (k === info.dotList.length - 1) ? 0 : k + 1;
        const floorInfo = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeightOfFloor(info.floor);
        // const width = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(info.dotList[startPoint].point, info.dotList[endPoint].point)));
        // const height = floorInfo.ceilingHeight - floorInfo.floorHeight;
        // const area = ((width / 1000) * (height / 1000)).toFixed(3);

        const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
        const habakiH: number = jsonData.height.habaki_height;

        const width = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.core.Point.distance(info.dotList[startPoint].point, info.dotList[endPoint].point)));
        const height = floorInfo.ceilingHeight - floorInfo.floorHeight - habakiH;
        let area = (parseFloat(((width / 1000) * (height / 1000)).toFixed(2))).toFixed(3);
        if ((parseFloat(((width / 1000) * (height / 1000)).toFixed(2))) < 0) area = '0'; // 建具面積が壁面積を上回る場合は0にする

        let end_item: MasterItemCollection = info.dotList[startPoint].inner_end_item_info;
        if (!end_item) {
          if (info.dotList[startPoint].inner_white_item_info) end_item = info.dotList[startPoint].inner_white_item_info;
        }
        if (end_item) end_item.symbol_2d_code = 'wallpaper';

        hasAuxiliary = AuxiliaryUtil.hasAuxiliaryWithCheckOn(info.dotList[startPoint].guid);
        includeInQuote = data?.is_quote;
        //STARTS_LIDAR-2029 見積画面への付帯工事が紐づけられているアイテムの非表示化
        //付帯工事がONであれば、親工事をONにする処理はOFF
        // if (hasAuxiliary) includeInQuote = true;

        const pushData: QuotationListCollection = new QuotationListCollection();
        pushData.arrayIndex = i;
        pushData.is_quote = includeInQuote;
        pushData.name = '柱';
        pushData.floor = info.floor;
        pushData.width = width;
        pushData.depth = '-';
        pushData.height = height;
        pushData.area = area;
        pushData.unit = end_item ? end_item.item_unit : '㎡';
        pushData.maker = end_item ? end_item.item_maker_name : '';
        pushData.part_number = end_item ? end_item.item_part_number : '';
        pushData.item_name = end_item ? end_item.item_name : '';
        pushData.item_sub_category = end_item ? end_item.item_sub_category : '';
        pushData.area = area;
        pushData.unit_price = end_item ? end_item.item_unit_price : '-';
        pushData.price = end_item ? Math.round(end_item.item_unit_price * Number.parseFloat(area)) : '-';
        pushData.item_set_date = data && data.item_set_date ? data.item_set_date : (marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
        pushData.maker = end_item ? end_item.item_maker_name : '';
        pushData.note = end_item ? end_item.item_memo : '';
        pushData.guid = info.dotList[startPoint].guid;
        pushData.room_name = info.parentRoom ? info.parentRoom.itemInfo.text : '';
        pushData.item_id = end_item ? end_item.item_id : '-';
        pushData.end_item_info = end_item || null;
        pushData.documents = info.documents;

        this.tableDataColumn.push(pushData);

        let { habaki_end_item_info } = info.dotList[startPoint];
        if (!habaki_end_item_info) {
          if (info.dotList[startPoint].habaki_white_item_info) habaki_end_item_info = info.dotList[startPoint].habaki_white_item_info;
        }
        if (habaki_end_item_info) habaki_end_item_info.symbol_2d_code = 'habaki';

        const infoHabaki: HabakInfo = {
          index: i,
          itemInfo: info,
          habaki_guid: `${info.dotList[startPoint].guid}_habaki`,
          parentItem: this.columnItemList[i] as MonicaObject,
          width,
          height: habakiH,
          habaki_documents: [],
          habaki_end_item_info,
          room_name: '',
          price: (habaki_end_item_info) ? Math.round(habaki_end_item_info.item_unit_price * Number.parseFloat(area))
            .toString(10) : '-',
        };

        const habakiData: QuotationListCollection = this.createHabakiData(infoHabaki);

        // const habakiData:QuotationListCollection = new QuotationListCollection();
        // habakiData.arrayIndex = i;
        // habakiData.is_quote = data2 ? data2.is_quote : false;
        // habakiData.name = '∟巾木';
        // habakiData.floor = info.floor;
        // habakiData.width = width;
        // habakiData.depth = '-';
        // habakiData.height = habakiH;
        // habakiData.area = width.toString(10), // (parseFloat(((width / 1000) * (50 / 1000)).toFixed(2))).toFixed(3);
        // habakiData.unit = 'mm'; // (habaki_end_item_info)?habaki_end_item_info.item_unit:'-';
        // habakiData.maker = (habaki_end_item_info) ? habaki_end_item_info.item_maker_name : '';
        // habakiData.part_number = (habaki_end_item_info) ? habaki_end_item_info.item_part_number : '-';
        // habakiData.item_name = (habaki_end_item_info) ? habaki_end_item_info.item_name : '';
        // habakiData.item_sub_category = (habaki_end_item_info) ? habaki_end_item_info.item_sub_category : '-';
        // habakiData.unit_price = (habaki_end_item_info) ? habaki_end_item_info.item_unit_price : '-';
        // habakiData.price = (habaki_end_item_info) ? Math.round(habaki_end_item_info.item_unit_price * Number.parseFloat(area)) : '-';
        // habakiData.item_set_date = (data2 && data2.item_set_date) ? data2.item_set_date : ((marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date) ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
        // habakiData.note = (habaki_end_item_info) ? habaki_end_item_info.item_memo : '';
        // habakiData.documents = info.dotList[startPoint].habaki_documents;
        // habakiData.guid = `${info.dotList[startPoint].guid}_habaki`;
        // habakiData.room_name = '';
        // habakiData.item_id = (habaki_end_item_info) ? habaki_end_item_info.item_id : '-';
        // habakiData.end_item_info = (habaki_end_item_info) || null;
        // habakiData.isHabaki = true; // tableDataWallに巾木のデータが入っているようなのでフラグを追;
        // habakiData.item = (this.columnItemList[i] as MonicaObject);

        this.tableDataColumn.push(habakiData);
      }

      console.log(this.tableDataColumn);
    }
  }

  private createHabakiData(info: HabakInfo): QuotationListCollection {
    const currentData = this.tableDataQuotation.find((d) => (d.guid === info.habaki_guid && d.name.indexOf('巾木') > -1));

    const habakiData: QuotationListCollection = new QuotationListCollection();
    habakiData.arrayIndex = info.index;
    habakiData.is_quote = currentData ? currentData.is_quote : false;
    habakiData.name = '∟巾木';
    habakiData.floor = info.itemInfo.floor;
    habakiData.width = info.width;
    habakiData.depth = '-';
    habakiData.height = info.height;
    habakiData.area = (info.width / 1000).toString(10),
      habakiData.unit = 'm'; // (habaki_end_item_info)?habaki_end_item_info.item_unit:'-';
    habakiData.maker = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_maker_name : '';
    habakiData.part_number = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_part_number : '';
    habakiData.item_name = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_name : '';
    habakiData.item_sub_category = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_sub_category : '';
    habakiData.unit_price = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_unit_price : '-';
    habakiData.price = info.price;
    habakiData.item_set_date = currentData && currentData.item_set_date ? currentData.item_set_date : marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null;
    habakiData.note = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_memo : '';
    habakiData.documents = info.habaki_documents;
    habakiData.guid = info.habaki_guid;
    habakiData.room_name = info.room_name;
    habakiData.item_id = (info.habaki_end_item_info) ? info.habaki_end_item_info.item_id : '-';
    habakiData.end_item_info = (info.habaki_end_item_info) || null;
    habakiData.isHabaki = true;
    habakiData.item = info.parentItem;

    return habakiData;
  }

  /**
   *建具データ
   */
  createFitting() {
    this.fittingItemList = [];
    this.tableDataFitting = [];
    const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let floor = 1; floor <= highestFloor; floor++) {
      this.fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_FITTING_NO)).getAllChildren());
      this.fittingItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_FITTINGDOWN1_NO)).getAllChildren());
    }
    for (let i: number = 0; i < this.fittingItemList.length; i += 1) {
      // (this.fittingItemList[i] as Fitting).snapToWall(false);
      const info: ItemInfoCollection = (this.fittingItemList[i] as MonicaObject).itemInfo;
      const data = this.tableDataQuotation.find((d) => d.guid === info.guid);
      let snapWallId: string = '';
      if (this.fittingItemList[i].snapWall) {
        if (this.fittingItemList[i].snapWall.parentObj instanceof WallObject) {
          snapWallId = this.fittingItemList[i].snapWall.parentObjInfo.guid;
        } else {
          snapWallId = this.fittingItemList[i].snapWall.startDot.guid;
          info.parentRoom = this.fittingItemList[i].snapWall.parentObj as marietta.webcad.item.Room;
        }
      } else {
        info.parentRoom = null;
      }
      // 壁アイテム系のサイズ情報
      const pushData: QuotationListCollection = this.createDataObject(i, 'fitting', data, info);
      switch (info.id) {
        case 'fit01_01':
        case 'fit01_02':
        case 'fit01_03':
          const floorInfo = marietta.webcad.WebCADGlobal.itemManager.getFloorAndCeilingHeightOfFloor(info.floor);
          const floor_height = floorInfo.ceilingHeight - floorInfo.floorHeight;
          pushData.width = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(info.width));
          pushData.height = isNaN(info.fitting_height) ? floor_height : info.fitting_height;
          if (info.id === 'fit01_01') {
            pushData.height = floor_height;
          }
          pushData.depth = ' - ';
          pushData.area = (Math.round(pushData.width * pushData.height / 10000) / 100).toString(10);
          pushData.unit = '㎡';

          break;
      }
      pushData.snapWallId = snapWallId;
      pushData.documents = this.fittingItemList[i].itemInfo.documents;

      this.tableDataFitting.push(pushData);

      // 独立壁、腰壁は、巾木も計上する
      if (info.id == 'fit01_01' || info.id == 'fit01_03') {
        // 巾木
        const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
        const infoHabaki: HabakInfo = {
          index: i,
          itemInfo: info,
          habaki_guid: `${info.guid}_habaki`,
          parentItem: this.fittingItemList[i][i] as MonicaObject,
          width: parseFloat((pushData.width).toString()),
          height: jsonData.height.habaki_height,
          habaki_end_item_info: null,
          habaki_documents: [],
          price: '-',
          room_name: info.parentRoom ? (info.parentRoom.itemInfo.text.length ? info.parentRoom.itemInfo.text : '（空白）') : '',
        };
        const habakiData: QuotationListCollection = this.createHabakiData(infoHabaki);

        // habakiData.arrayIndex = i;
        // habakiData.is_quote = data2 ? data2.is_quote : false;
        // habakiData.name = '∟巾木';
        // habakiData.floor = info.floor;
        // habakiData.width = pushData.width;
        // habakiData.depth = '-';
        // habakiData.height = habakiH;
        // habakiData.area = pushData.width.toString(10), // (parseFloat(((width / 1000) * (50 / 1000)).toFixed(2))).toFixed(3);
        // habakiData.unit = 'mm'; // (habaki_end_item_info)?habaki_end_item_info.item_unit:'-';
        // habakiData.maker = (habaki_end_item_info) ? habaki_end_item_info.item_maker_name : '';
        // habakiData.part_number = (habaki_end_item_info) ? habaki_end_item_info.item_part_number : '-';
        // habakiData.item_name = (habaki_end_item_info) ? habaki_end_item_info.item_name : '';
        // habakiData.item_sub_category = (habaki_end_item_info) ? habaki_end_item_info.item_sub_category : '-';
        // habakiData.unit_price = (habaki_end_item_info) ? habaki_end_item_info.item_unit_price : '-';
        // habakiData.price = (habaki_end_item_info) ? Math.round(habaki_end_item_info.item_unit_price * info.width) : '-';
        // habakiData.item_set_date = (data2 && data2.item_set_date) ? data2.item_set_date : ((marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date) ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
        // habakiData.note = (habaki_end_item_info) ? habaki_end_item_info.item_memo : '';
        // habakiData.documents = null;
        // habakiData.guid = `${info.guid}_habaki`;
        // habakiData.room_name = info.parentRoom ? (info.parentRoom.itemInfo.text.length ? info.parentRoom.itemInfo.text : '（空白）') : '';
        // habakiData.item_id = (habaki_end_item_info) ? habaki_end_item_info.item_id : '-';
        // habakiData.end_item_info = (habaki_end_item_info) || null;
        // habakiData.isHabaki = true; // tableDataWallに巾木のデータが入っているようなのでフラグを追;
        // habakiData.item = (<MonicaObject>this.fittingItemList[i][i]);

        this.tableDataFitting.push(habakiData);
      }
    }
    this.applyPinRoomNameToFittings();
  }

  /**
   * 付帯工事のピンが紐づいている建具は、ピン側で決めた部屋名に合わせる。
   * 建具は壁の中心線上にあり所属部屋が一意に定まらないため、ピン側の部屋名を正とする。
   */
  private applyPinRoomNameToFittings(): void {
    const fittings = this.tableDataFitting ?? [];
    for (let i: number = 0; i < fittings.length; i += 1) {
      const roomName = AuxiliaryUtil.getRoomNameByIntersectUid(fittings[i].guid);
      if (roomName) fittings[i].room_name = roomName;
    }
  }

  /**
   *住設データ
   */
  createEquipment() {
    this.equipmentItemList = [];
    this.tableDataEquipment = [];
    const heighestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let floor = 1; floor <= heighestFloor; floor++) {
      this.equipmentItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_EQUIPMENT_NO)).getAllChildren());
    }
    // 家具も同じリストにするupdateRoomTextForAllTables
    for (let floor = 1; floor <= heighestFloor; floor++) {
      this.equipmentItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_FURNITURE_NO)).getAllChildren());
    }

    for (let i: number = 0; i < this.equipmentItemList.length; i += 1) {
      const info: ItemInfoCollection = (this.equipmentItemList[i] as MonicaObject).itemInfo;
      const data = this.tableDataQuotation.find((d) => d.guid === info.guid);

      // 照明以外は、見積に含めないのでスキップ
      if (!marietta.webcad.WebCADGlobal.isItemForQuotation(info.id)) continue;
      const pushData: QuotationListCollection = this.createDataObject(i, 'equipment', data, info);
      this.tableDataEquipment.push(pushData);
    }
  }

  /**
   *外構データ
   */
  createExterior() {
    this.exteriorItemList = [];
    this.tableDataExterior = [];
    const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let floor = 1; floor <= highestFloor; floor++) {
      this.exteriorItemList.push(...(marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_EXTERIOR_NO)).getAllChildren());
    }
    for (let i: number = 0; i < this.exteriorItemList.length; i += 1) {
      const info: ItemInfoCollection = (this.exteriorItemList[i] as MonicaObject).itemInfo;
      const data = this.tableDataQuotation.find((d) => d.guid === info.guid);

      // 照明以外は、見積に含めないのでスキップ
      if (!marietta.webcad.WebCADGlobal.isItemForQuotation(info.id)) continue;
      const pushData: QuotationListCollection = this.createDataObject(i, 'exterior', data, info);
      this.tableDataExterior.push(pushData);
    }
  }

  /**
   *付帯工事データ
   */
  createAuxiliary() {
    this.auxiliaryItemList = AuxiliaryUtil.getAuxiliaryList();
    const prevAuxiliary = this.tableDataAuxiliary ?? [];
    this.tableDataAuxiliary = [];

    for (let i: number = 0; i < this.auxiliaryItemList.length; i += 1) {
      const data = prevAuxiliary.find((d) => d.guid === this.auxiliaryItemList[i].guid);
      const pushData: QuotationListCollection = this.createAuxiliaryDataObject(i, data, this.auxiliaryItemList[i]);
      this.tableDataAuxiliary.push(pushData);
    }
    // 順番の入れ替え
    this.tableDataAuxiliary = _.sortBy(this.tableDataAuxiliary, (obj) => obj.guid);
  }

  /**
   * createDataObject
   * @private
   * @param index
   * @param type
   * @param moto_data
   * @param info
   */
  private createDataObject(index: number, type: string, moto_data: any = null, info: ItemInfoCollection  = null): QuotationListCollection {
    const retValue: QuotationListCollection = new QuotationListCollection();

    const hasAuxiliary = AuxiliaryUtil.hasAuxiliaryWithCheckOn(info.guid);
    let includeInQuote = moto_data?.is_quote;

    //STARTS_LIDAR-2029 見積画面への付帯工事が紐づけられているアイテムの非表示化
    //付帯工事がONであれば、親工事をONにする処理はOFF
    // if (hasAuxiliary) includeInQuote = true;

    // 汎用
    retValue.arrayIndex = index;
    retValue.is_quote = includeInQuote;
    switch (type) {
      case 'fitting':
        retValue.name = info.text ? info.text : '';
        if (retValue.name.length < 1 && info.id === 'fit01_01') retValue.name = '壁';
        break;
      case 'column':
        retValue.name = '柱';
        break;
      case 'beam':
        retValue.name = '梁';
        break;
      default: // 住設・家具
        retValue.name = info.end_item_info ? info.end_item_info.symbol_name : info.text;
        break;
    }
    let dataToReferTo: MasterItemCollection = info.end_item_info;

    retValue.floor = info.floor;
    if (dataToReferTo) {
      // 住設・家具はフッターのサイズ欄と同じ getItemSize から取る（商品付きはマスタの値）
      const size: { width: number, depth: number, height: number } = marietta.webcad.WebCADGlobal.isHeightEditableItem(info.id)
        ? marietta.webcad.WebCADGlobal.getItemSize(info)
        : { width: dataToReferTo.item_width, depth: dataToReferTo.item_depth, height: dataToReferTo.item_height };
      retValue.width = size.width;
      retValue.depth = size.depth;
      retValue.height = size.height;
    } else {
      switch (type) {
        case 'fitting':
          retValue.width = (info.widthmm === undefined || Number.isNaN(info.widthmm)) ? null : info.widthmm;
          retValue.depth = (info.depth === undefined || Number.isNaN(info.depth)) ? null : info.depth;
          retValue.height = info.fitting_height;
          // 自動高さの場合
          if (info.auto_height) {
            retValue.height = marietta.webcad.WebCADGlobal.getFittingHeight(info.idthreed && info.idthreed != 'null' ? info.idthreed : info.id);
          }

          switch (info.id) {
            case 'fit01_02':
            case 'fit01_03':
              if (!isNaN(info.fitting_height) && info.fitting_height != null) {
                retValue.height = info.fitting_height;
              }
              break;
          }
          break;
        default: { // 住設・家具（フッターのサイズ欄と同じ getItemSize から取る）
          const size: { width: number, depth: number, height: number } = marietta.webcad.WebCADGlobal.getItemSize(info);
          retValue.width = (size.width === undefined || Number.isNaN(size.width)) ? null : Number.parseFloat((size.width).toFixed(3));
          retValue.depth = (size.depth === undefined || Number.isNaN(size.depth)) ? null : Number.parseFloat((size.depth).toFixed(3));
          retValue.height = (size.height === undefined || Number.isNaN(size.height)) ? null : Math.round(size.height)
            .toFixed(0);
          break;
        }
      }
    }

    if (!dataToReferTo) { // STARTS_LIDAR-1770 汎用オブジェクトの寸法が0になってしまう。
      if (info.white_item_info) dataToReferTo = info.white_item_info;
    }

    switch (type) {
      case 'column':
        retValue.area = marietta.webcad.util.WebCADUtil.calculateArea(info.dotList, false)
          .toString();
        break;
      case 'beam':
        retValue.area = marietta.webcad.util.WebCADUtil.calculateArea(info.dotList, false)
          .toString();
        break;
      default:
        retValue.area = '1';
        break;
    }

    retValue.unit = (dataToReferTo) ? dataToReferTo.item_unit : '-';
    retValue.maker = (dataToReferTo) ? dataToReferTo.item_maker_name : '';
    retValue.part_number = (dataToReferTo) ? dataToReferTo.item_part_number : '';
    retValue.item_name = (dataToReferTo) ? dataToReferTo.item_name : '';
    retValue.item_sub_category = (dataToReferTo) ? dataToReferTo.item_sub_category : '';
    retValue.unit_price = (dataToReferTo) ? dataToReferTo.item_unit_price : '-';
    retValue.price = (dataToReferTo) ? Math.round(dataToReferTo.item_unit_price * Number.parseFloat(retValue.area)) : '-';
    retValue.item_set_date = moto_data && moto_data.item_set_date ? moto_data.item_set_date : (marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date ? marietta.webcad.WebCADGlobal.webcad2Dmanager.contracted_date : null);
    retValue.note = (dataToReferTo) ? dataToReferTo.item_memo : '';
    retValue.room_name = info.parentRoom ? info.parentRoom.itemInfo.text : '';
    retValue.item = info.parentRoom ? info.parentRoom : null;
    retValue.item_id = (dataToReferTo) ? dataToReferTo.item_id : '-';
    retValue.guid = info.guid;
    retValue.documents = info.documents;
    retValue.end_item_info = (dataToReferTo) ? info.end_item_info : null;
    if (!retValue.end_item_info && info.white_item_info) {
      retValue.end_item_info = info.white_item_info;
    }
    if (retValue.end_item_info && !retValue.end_item_info.symbol_2d_code) {
      retValue.end_item_info.symbol_2d_code = info.id;
    }
    retValue.is_auxiliary_data = false;

    return retValue;
  }

  /**
   * createDataObject
   * @private
   * @param index
   * @param type
   * @param moto_data
   * @param info
   */
  private createAuxiliaryDataObject(index: number, moto_data: any = null, info: AuxiliaryConstructionCollection = null): QuotationListCollection {
    const retValue: QuotationListCollection = new QuotationListCollection();
    const itemInfo = info.parentPin.itemInfo;
    const datum = itemInfo.auxiliaryData?.auxiliaryDatum;
    const linkId = itemInfo?.link[0]?.id;
    const matchedRemark = itemInfo.remarks.find((r) => r.id === linkId)?.text;

    retValue.arrayIndex = index;
    retValue.is_quote = Boolean(info.estimatedEntryFlg);
    retValue.guid = info.guid;
    retValue.name = info.auxiliary_construction_name;
    retValue.item_name = info.auxiliary_construction_name;
    retValue.item_id = info.id;
    retValue.unit = info.unit;
    retValue.unit_price = info.unit_price;
    retValue.price = Math.floor((datum?.quantity ?? 0) * (datum?.unitPrice ?? 0));
    retValue.area = (info.quantity ?? 0).toString(10);
    retValue.note = info.note;
    retValue.remarks = matchedRemark ?? datum?.remarks;
    // retValue.room_name = info.room_name
    //   || marietta.webcad.WebCADGlobal.webcad2Dmanager.getRoomWithPin(itemInfo)?.itemInfo.text
    //   || '';

    const intersectItem = info.parentPin.itemInfo?.intersectItem;
    const intersectItemInfo = PinDialogUtil.getCurrentItem(intersectItem?.uid);
    const iteminfo = intersectItemInfo instanceof MonicaObject ? intersectItemInfo.itemInfo : intersectItemInfo?.parentObj?.itemInfo;

    //データに入っているものを使用
    retValue.room_name = info.room_name; //itemInfo?.intersectItem?PinDialogUtil.getItemRoomName( iteminfo, intersectItem) :null;

    //付帯工事は、部屋名は別のところから取ってくる
    if( info.parentPin != null ){
      retValue.room_name = info.parentPin.itemInfo?.auxiliaryData?.auxiliaryDatum.room_name??null;
    }
    

    retValue.rate = datum?.rate != null ? datum.rate * 100 : datum?.rate;
    retValue.reason = datum?.repair;
    retValue.item = info.parentRoom ?? null;
    retValue.intersectItem = PinDialogUtil.getItemName(iteminfo, intersectItem);
    retValue.parentPin = info.parentPin;
    retValue.other_flag = info.other_flag;
    retValue.other_text = info.other_flag ? info.other_text : '';
    retValue.is_auxiliary_data = true;

    // other_flag が false の場合はマスタから constructionId で正式名称を取得して上書き
    if (!info.other_flag && datum?.constructionId) {
      const master = marietta.webcad.WebCADGlobal.AUXILIARY_MASTER;
      const allCategories = [...(master?.company ?? []), ...(master?.default ?? [])];
      const masterConstruction = allCategories
        .flatMap((m) => m.sub_categories)
        .flatMap((s) => s.auxiliary_constructions)
        .find((c) => c.id === datum.constructionId);
      if (masterConstruction) {
        if (datum.construction !== masterConstruction.name) {
          console.warn('[付帯工事名不一致] guid:', info.guid, {
            constructionId:    datum.constructionId,
            保存されていた名前: datum.construction,
            マスタの正式名称:   masterConstruction.name,
          });
        }
        retValue.name = masterConstruction.name;
        retValue.item_name = masterConstruction.name;
        datum.construction = masterConstruction.name;
      }
    }
    return retValue;
  }

  /** 修繕理由セレクトボックスのHTML生成 */
  private buildReasonSelect(modeNo: number, row: QuotationListCollection): string {
    const attrs = `data-mode="${modeNo}" data-property="reason" data-guid="${row.guid}" id="reason_${row.guid}" name="reason_${row.guid}" class="quote_list"`;
    const reasons = marietta.webcad.WebCADGlobal.REPAIR_MASTER?.repair_reasons ?? [];
    const options = [
      '<option value=""></option>',
      ...reasons.map((r) => `<option value="${r.name}" data-id="${r.id}" ${row.reason === r.name ? 'selected' : ''}>${r.name}</option>`),
    ].join('');
    return `<select ${attrs}>${options}</select>`;
  }

  /** 部屋名セレクト＋自由入力テキストボックスのHTML生成 */
  private buildRoomNameCell(modeNo: number, row: QuotationListCollection): string {
    const roomList = ['全体', ...WebCADUtil.getExisitingRoomNames(), 'その他'];
    // null / undefined / 空文字は未選択扱いとして select 側を表示する
    let isCustom = Boolean(row.room_name && !roomList.includes(row.room_name));
    if (row.room_name === 'その他') isCustom = true;
    const attrs = `data-mode="${modeNo}" data-property="room_name" data-guid="${row.guid}" id="room_name_${row.guid}" name="room_name_${row.guid}" class="quote_list"`;
    const options = roomList
      .map((name) => `<option value="${name}" ${row.room_name === name ? 'selected' : ''}>${name}</option>`)
      .join('');
    const select = `<select ${attrs} style="display:${isCustom ? 'none' : 'inline-block'};width:150px;box-sizing:border-box">${options}</select>`;
    const textAttrs = `data-mode="${modeNo}" data-property="room_name" data-guid="${row.guid}" id="room_name_text_${row.guid}" name="room_name_text_${row.guid}" class="quote_room_name_text"`;
    const textbox = `<input type="text" ${textAttrs} autocomplete="off" value="${row.room_name ?? ''}" style="display:${isCustom ? 'inline-block' : 'none'};width:150px;box-sizing:border-box">`;
    return select + textbox;
  }

  /** 付帯工事テーブル編集時に auxiliaryDatum へ値を書き戻す */
  private updateAuxiliaryDatum(
    pin: PinPicture,
    data: QuotationListCollection,
    guid: string,
    property: string,
    val: string,
    sourceElement?: HTMLElement,
  ): void {
    const { itemInfo } = pin;
    const datum = itemInfo.auxiliaryData.auxiliaryDatum;
    datum.estimatedEntryFlg = Number( data.is_quote );
    datum.quantity  = Number(data.area);
    datum.unitPrice = Number(data.unit_price);
    datum.unit      = data.unit;
    datum.rate      = Number(data.rate) / 100;
    datum.repair    = data.reason;
    datum.repairId  = marietta.webcad.WebCADGlobal.REPAIR_MASTER?.repair_reasons
      ?.find((r) => r.name === data.reason)?.id ?? datum.repairId;

    data.price      = Number(data.area) * Number(data.unit_price);
    document
      .querySelector(`tr[data-id="auxiliary_${guid}"] td[data-property="price"]`)
      .textContent = Math.floor(data.price).toLocaleString("ja-JP");

    const linkId = itemInfo?.link[0]?.id;
    const matchedRemark = itemInfo.remarks.find((r) => r.id === linkId);
    if (matchedRemark) {
      matchedRemark.text = data.remarks;
    } else {
      datum.remarks = data.remarks;
    }

    const selectBox    = document.getElementById(`room_name_${data.guid}`) as HTMLSelectElement;
    const otherTextBox = document.getElementById(`room_name_text_${data.guid}`) as HTMLInputElement;
    let roomName = datum.room_name;

    if (property == 'room_name') {
      let showTextBox = false;
      const isFromSelect = sourceElement?.tagName === 'SELECT';

      if (isFromSelect) {
        if (val === 'その他') {
          // セレクトで「その他」を選んだ瞬間 → 空のテキストボックスへ切替
          showTextBox = true;
          roomName = '';
          otherTextBox.value = '';
        } else {
          // セレクトで「その他」以外を選んだ → 値をそのまま保存
          roomName = val;
          otherTextBox.value = '';
        }
      } else {
        if (val === '') {
          // テキストボックスを空にして blur → セレクトに戻す
          showTextBox = false;
          roomName = '';
        } else {
          // テキストボックスに入力した値をそのまま保存（"その他" 文字列含む）
          showTextBox = true;
          roomName = val;
        }
      }

      data.room_name = roomName;
      selectBox.style.display    = showTextBox ? 'none'         : 'inline-block';
      otherTextBox.style.display = showTextBox ? 'inline-block' : 'none';
    }

    datum.room_name = data.room_name = roomName;

    // 建具行はピン側の部屋名に追従させるため、編集直後に反映し直す
    if (property === 'room_name') this.applyPinRoomNameToFittings();

    if (property === 'name') {
      datum.otherText    = datum.other_flag ? val : '';
      datum.construction = val;
      const auxiliaryItem = this.auxiliaryItemList.find((a) => a.guid === guid);
      if (auxiliaryItem) {
        auxiliaryItem.other_text = datum.otherText;
        auxiliaryItem.auxiliary_construction_name = val;
      }
    }

    /** ピン更新APIフラグを立てる */
    itemInfo.is_pin_update_flg = true;
  }

  private createTable_(tableData, mode: number): string {
    let content: string = '';
    if (tableData == null || tableData === undefined) return content;
    const typeName = this.getModeName(mode);
    const modeNo = this.getModeByName(typeName);
    let rowModeNo = mode;
    if (tableData.length > 0) {
      for (let i = 0; i < tableData.length; i += 1) {
        let endItemInfo = 0;
        if (tableData[i].end_item_info) {
          endItemInfo = 1;
        }
        if (tableData[i]?.isHabaki) { // 巾木のデータもwallと一色単になっているようなのでこちらに追加
          rowModeNo = QUOTATION_ITEM_LIST_TYPE_MODE.MODE_HABAKI_TYPE_NO;
        } else {
          rowModeNo = mode;
        }
        content += `<tr data-arrayIndex="${tableData[i].arrayIndex}" data-id="${typeName}_${tableData[i].guid}" id="${typeName}_${tableData[i].guid}" data-enditem="${endItemInfo}" itemtype="${tableData[i].name}" data-mode="${modeNo}" data-floor="${tableData[i].floor}" class="itemListContainer itemListContainerArea">`;
        for (const [property, valueData] of this.dataList) {
          if (tableData[i].hasOwnProperty(property)) {
            // if( property == "guid" || property == "room_name" || property == "item_name" ||property == "item_id" ) continue;

            let value = tableData[i][property];

            // 全て選択可能にする
            const disabled = '';
            // if (!tableData[i].end_item_info) {
            //   disabled = 'disabled="disabled"';
            //   if (this.dataList.get(property).type === 'checkbox') {
            //     tableData[i][property] = false;
            //   }
            // }
            if (this.dataList.get(property).type === 'checkbox') {
              value = `<input type="checkbox" data-mode="${rowModeNo}" data-guid="${tableData[i].guid}" class="quote_check" ${(tableData[i][property] ? 'checked=checked' : '')} ${disabled}>`;
            } else if (this.dataList.get(property).type === 'textbox') {
              value = `<input type="text" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
            } else if (this.dataList.get(property).type === 'textbox_number') {
              value = `<input type="number" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_number"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
            } else if (this.dataList.get(property).type === 'textbox_integer') {
              value = `<input type="number" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_number"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
            } else if (this.dataList.get(property).type === 'textbox_rate') {
              value = `<input type="number" min="0" max="100" step="1" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_number"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">％`;
            } else if (this.dataList.get(property).type === 'textbox_date') {
              if (marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type == 1) {
                value = `<input type="date" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_date"  disabled id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
              } else {
                value = `<input type="date" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_date"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
              }
            } else if (property === 'isCeiling') {
              value = `${(value ? '<span class="isCeiling"></span>' : '<span class="notCeiling"></span>')}`;
            } else if (property === 'area') {
              // //小数点以下がある場合は、下3桁まで表示する
              // if( value%1 && tableData[i].item_unit == '㎡'){
              //   value = parseFloat(value).toFixed(3);   //下3桁に丸める
              // }

              if (tableData[i].unit == '㎡') {
                value = parseFloat(value)
                  .toFixed(3); // 下3桁に丸める
              }
            } else if (property === 'price') {
              if (typeof value === 'number') {
                value = marietta.webcad.util.WebCADUtil.priceFormat(value);
              }
            } else if (property === 'documents') {
              if (tableData[i].documents == null || tableData[i].documents.length === 0) {
                value = `&emsp;&emsp;－&emsp;&emsp;<button class="btnDocumentsAdd btn" data-guid="${tableData[i].guid}" itemtype="${tableData[i].name}" data-arrayIndex="${tableData[i].arrayIndex}" data-floor="${tableData[i].floor}"><span class="jp">追加</span><span class="en">Add</span></button>`;
              } else {
                value = `<a class="btnDocumentsShow" data-guid="${tableData[i].guid}" itemtype="${tableData[i].name}" data-arrayIndex="${tableData[i].arrayIndex}" data-floor="${tableData[i].floor}">&emsp;●&emsp;</a>`;
                value += `<button class="btnDocumentsEdit btn" data-guid="${tableData[i].guid}" itemtype="${tableData[i].name}" data-arrayIndex="${tableData[i].arrayIndex}" data-floor="${tableData[i].floor}"><span class="icon icon-edit"></span></button>`;
                value += `<button class="btnDocumentsDel btn" data-guid="${tableData[i].guid}" itemtype="${tableData[i].name}" data-arrayIndex="${tableData[i].arrayIndex}" data-floor="${tableData[i].floor}"><span class="icon icon-garbage"></span></button>`;
              }
            } else if (property === 'name' && mode === QUOTATION_ITEM_LIST_TYPE_MODE.MODE_AUXILIARY_TYPE_NO) {
              const nameInput = tableData[i].other_flag
                ? `<input type="text" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox quote_auxiliary_name" id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${tableData[i].other_text ?? value ?? ''}" style="flex:1;min-width:0;">`
                : `<span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${value ?? ''}</span>`;
              value = `<div style="display:flex;align-items:center;gap:4px;">${nameInput}<button class="btn_auxiliary_change" data-guid="${tableData[i].guid}">▼</button></div>`;
            } else if (property === 'rate') {
              value = `<input type="number" min="0" max="100" step="1" data-mode="${rowModeNo}" data-property="${property}" data-guid="${tableData[i].guid}" class="quote_textbox_number"  ${disabled} id="${property}_${tableData[i].guid}" name="${property}_${tableData[i].guid}" value="${value}">`;
            } else if (property === 'reason') {
              value = this.buildReasonSelect(rowModeNo, tableData[i]);
            } else if (this.dataList.get(property).type === 'room_name_list') {
              value = this.buildRoomNameCell(rowModeNo, tableData[i]);
            }

            content += `<td data-property="${property}" class="${property === 'rate'?'rateTd':''}" style="text-align:${this.dataList.get(property).align}">${(value !== undefined && value !== null) ? value : ''}</td>`;

          }
        }
        // content += `<td><button class="btnHistory" data-roomName="${tableData[i].room_name}" data-partno="${tableData[i].part_number}" ${tableData[i].part_number=='-'?'disabled':''}>閲覧</button></td>`;
        if( mode != QUOTATION_ITEM_LIST_TYPE_MODE.MODE_AUXILIARY_TYPE_NO ){
          content += `<td style="text-align:center;"><button class="btnHistory btn" data-roomName="${tableData[i].room_name}" data-itemid="${tableData[i].item_id}"  data-guid="${tableData[i].guid}"}><span class="jp">閲覧</span><span class="en">View</span></button></td>`;
        }

        content += '</tr>';
      }
    }
    return content;
  }

  label: string;

  label_en: string;

  /**
   * 矢印のアイコンの向き
   */
  _footerListOpen: boolean = false;

  get footerListOpen() {
    return this._footerListOpen;
  }

  set footerListOpen(value) {
    this._footerListOpen = value;

    if (!value) {
      document.querySelector('#btnShowQuotationList .btnImg').innerHTML = `<span class="open"></span><span class="jp">${this.label}</span><span class="en">${this.label_en}</span>`;
      (<HTMLElement>document.querySelector('#btnShowQuotationList .resizeController')).style.visibility = 'hidden';
      (<HTMLElement>document.querySelector('#btnShowQuotation')).style.width = '104px';
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.unselectedAll();
      }
    } else {
      document.querySelector('#btnShowQuotationList .btnImg').innerHTML = `<span class="close"></span><span class="jp">${this.label}</span><span class="en">${this.label_en}</span>`;
      (<HTMLElement>document.querySelector('#btnShowQuotationList .resizeController')).style.visibility = 'visible';
      (<HTMLElement>document.querySelector('#btnShowQuotation')).style.width = '70px';
    }
  }

  /**
   * ラベル初期化
   */
  initializeListLabel(): void {
    this.label = marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type === 1 ? '見積り' : '仕様情報';
    this.label_en = marietta.webcad.WebCADGlobal.webcad2Dmanager.operation_type === 1 ? 'Quote' : 'Spec';

    document.querySelector('#btnShowQuotationList .btnImg').innerHTML = `<span class="open"></span><span class="jp">${this.label}</span><span class="en">${this.label_en}</span>`;
  }

  private highlightWallInfo(): marietta.webcad.item.parts.Wall[] {
    // ヘッダー 囲みで壁を単体選択
    if (marietta.webcad.WebCADGlobal.itemManager.currentWall) {
      return [marietta.webcad.WebCADGlobal.itemManager.currentWall];
    }
    // リストから選択 / 囲みで壁を複数選択
    if (marietta.webcad.WebCADGlobal.itemManager.currentWallGroup) {
      return marietta.webcad.WebCADGlobal.itemManager.currentWallGroup.myItemList;
    }
    return [];
  }

  /**
   * ハイライトする壁の拾い出し
   * @returns
   */
  private highlightWalls(): marietta.webcad.item.parts.Wall[] {
    if (marietta.webcad.WebCADGlobal.itemManager.currentWall) {
      return [marietta.webcad.WebCADGlobal.itemManager.currentWall];
    }

    if (marietta.webcad.WebCADGlobal.itemManager.currentWallGroup) {
      return marietta.webcad.WebCADGlobal.itemManager.currentWallGroup.myItemList;
    }

    return [];
  }
}
